/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/ts/components/product/CustomizeCell.tsx":
/*!*****************************************************!*\
  !*** ./src/ts/components/product/CustomizeCell.tsx ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CustomizeCell": () => (/* binding */ CustomizeCell)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");

var CustomizeCell = function CustomizeCell(_ref) {
  var children = _ref.children,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {
      return null;
    } : _ref$onClick,
    selected = _ref.selected,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? '' : _ref$style,
    _ref$isImage = _ref.isImage,
    isImage = _ref$isImage === void 0 ? false : _ref$isImage;
  var styles = "".concat(style, " flex font-normal transition duration-500 ease-in-out ring-inset items-center xl:text-base text-sm cursor-pointer justify-center ").concat(isImage ? 'p-4' : 'xl:py-6 px-2 py-4', " mt-5 lg:mx-3 md:mx-2 mx-0.5 outline-none focus:ring-6 focus:ring-wine border-transparent ").concat(selected ? 'xl:ring-6 ring-4 ring-wine' : 'ring-2 ring-gray-200').trim();
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    tabIndex: 0,
    role: "button",
    "aria-pressed": "false",
    onKeyDown: function onKeyDown(e) {
      if (e.key === ' ' || e.key === 'Enter') {
        onClick(e);
      }
    },
    onClick: onClick,
    className: styles
  }, children);
};

/***/ }),

/***/ "./src/ts/components/product/CustomizeCharacterColor.tsx":
/*!***************************************************************!*\
  !*** ./src/ts/components/product/CustomizeCharacterColor.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CustomizeCharacterColor": () => (/* binding */ CustomizeCharacterColor)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _hooks_useChangeCustomizeValue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../hooks/useChangeCustomizeValue */ "./src/ts/hooks/useChangeCustomizeValue.tsx");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var _CustomizeCell__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./CustomizeCell */ "./src/ts/components/product/CustomizeCell.tsx");
/* harmony import */ var _hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../hooks/useIsMobile */ "./src/ts/hooks/useIsMobile.tsx");

var _document$querySelect;





// import {
//   character,
//   CharacterColorCodes,
//   CharacterColorNames
// } from '../../utils/type.helper';
var colors = JSON.parse(document.querySelector('#t-product-extra-data') ? (_document$querySelect = document.querySelector('#t-product-extra-data')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.innerHTML : 'null').colors;
var ColorSquare = function ColorSquare(_ref) {
  var onClick = _ref.onClick,
    name = _ref.name,
    code = _ref.code;
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_3__.ProductContext),
    state = _useContext.productState;
  var mobile = (0,_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_5__.useIsMobile)();
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    onClick: onClick,
    className: "flex items-center justify-start py-3 mx-1 border-b border-gray-300 cursor-pointer md:border-b-2 md:py-5 md:mx-5"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "flex transition duration-500 ease-in-out items-center justify-center md:w-8 md:h-8 w-4 h-4 ".concat(state.customize.characterColor === name ? 'bg-wine' : 'bg-gray-300', " rounded-full"),
    style: {
      minWidth: mobile ? '1rem' : '2rem'
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
    className: "md:w-2 md:h-3 w-1.5 h-2.5 transform rotate-45 border-b-2 border-r-2 border-white"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "w-4 h-4 mx-2 rounded-full md:min-w-8 md:h-8 md:mx-7",
    style: {
      backgroundColor: code,
      minWidth: mobile ? '1rem' : '2rem'
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "text-xs md:text-base"
  }, name));
};
var CustomizeCharacterColor = function CustomizeCharacterColor() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
    _useState2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
    _useState4 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useState3, 2),
    added = _useState4[0],
    setAdded = _useState4[1];
  var _useContext2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_3__.ProductContext),
    state = _useContext2.productState,
    dispatch = _useContext2.productDispatch;
  var handleColorPanelOpen = function handleColorPanelOpen(e) {
    if (e.target.closest('.js-color-panel-inner')) {
      return;
    }
    setOpen(!open);
    if (!added) {
      window.addEventListener('click', function (e) {
        if (!e.target.closest('.js-color-panel-outter')) {
          setOpen(false);
          setAdded(true);
        }
      });
    }
  };
  var changeCustomizeValue = (0,_hooks_useChangeCustomizeValue__WEBPACK_IMPORTED_MODULE_2__.useChangeCustomizeValue)(dispatch);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "grid grid-cols-2"
  }, colors.map(function (_ref2, index) {
    var name = _ref2.name,
      code = _ref2.code;
    if (index < 2) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_CustomizeCell__WEBPACK_IMPORTED_MODULE_4__.CustomizeCell, {
        key: name,
        onClick: function onClick() {
          changeCustomizeValue('characterColor', name);
          changeCustomizeValue('characterCode', code);
        },
        selected: state.customize.characterColor === name
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, name));
    } else if (index === 3) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_CustomizeCell__WEBPACK_IMPORTED_MODULE_4__.CustomizeCell, {
        key: "color-select-box",
        onClick: handleColorPanelOpen,
        style: "col-start-1 col-end-3 relative js-color-panel-outter",
        selected: false
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "flex items-center justify-between w-5/6"
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, "\u30AB\u30E9\u30FC\u3092\u9078\u629E(\u4E00\u8272\u304A\u9078\u3073\u304F\u3060\u3055\u3044)"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", {
        className: "lg:text-4xl text-2xl cursor-pointer font-extralight transition-all duration-700 ".concat(open ? 'transform rotate-45' : ''),
        onClick: function onClick() {
          return setOpen(!open);
        }
      }, "+")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        className: "".concat(open ? '' : 'hidden', " absolute js-color-panel-inner w-full bg-white ring-inset ring-2 justify-start left-0 py-2 grid grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 z-10 ring-gray-200 outline-none cursor-pointer"),
        style: {
          top: '98%'
        }
      }, colors.map(function (_ref3, index) {
        var name = _ref3.name,
          code = _ref3.code;
        if (index >= 2) return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(ColorSquare, {
          onClick: function onClick() {
            changeCustomizeValue('characterColor', name);
            changeCustomizeValue('characterCode', code);
          },
          key: name,
          name: name,
          code: code
        });
      })));
    }
  })));
};

/***/ }),

/***/ "./src/ts/components/product/CustomizeCharacterFont.tsx":
/*!**************************************************************!*\
  !*** ./src/ts/components/product/CustomizeCharacterFont.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CustomizeCharacterFont": () => (/* binding */ CustomizeCharacterFont)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _hooks_useChangeCustomizeValue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../hooks/useChangeCustomizeValue */ "./src/ts/hooks/useChangeCustomizeValue.tsx");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var _CustomizeCell__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./CustomizeCell */ "./src/ts/components/product/CustomizeCell.tsx");
/* harmony import */ var _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/type.helper */ "./src/ts/utils/type.helper.ts");
/* harmony import */ var _hooks_useKanaConverter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../hooks/useKanaConverter */ "./src/ts/hooks/useKanaConverter.tsx");
/* harmony import */ var _hooks_useLanguage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../hooks/useLanguage */ "./src/ts/hooks/useLanguage.tsx");
/* harmony import */ var _common_UnderCellText__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../common/UnderCellText */ "./src/ts/components/common/UnderCellText.tsx");


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var CustomizeCharacterFont = function CustomizeCharacterFont() {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_4__.ProductContext),
    state = _useContext.productState,
    dispatch = _useContext.productDispatch;
  var changeCustomizeValue = (0,_hooks_useChangeCustomizeValue__WEBPACK_IMPORTED_MODULE_3__.useChangeCustomizeValue)(dispatch);
  var _useKanaConverter = (0,_hooks_useKanaConverter__WEBPACK_IMPORTED_MODULE_7__.useKanaConverter)(),
    kataToHira = _useKanaConverter.kataToHira,
    hiraTokata = _useKanaConverter.hiraTokata;
  var langChecker = (0,_hooks_useLanguage__WEBPACK_IMPORTED_MODULE_8__.useLanguage)();
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
      JA: '',
      EN: ''
    }),
    _useState2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__["default"])(_useState, 2),
    langCache = _useState2[0],
    setLangCache = _useState2[1];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
    className: "flex flex-wrap items-center justify-around md:justify-center"
  }, _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.character.fonts.map(function (_ref) {
    var name = _ref.name,
      font = _ref.font,
      word = _ref.word,
      characterId = _ref.characterId;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
      key: name,
      className: "w-1/3"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_CustomizeCell__WEBPACK_IMPORTED_MODULE_5__.CustomizeCell, {
      onClick: function onClick() {
        changeCustomizeValue('characterId', characterId);
        changeCustomizeValue('characterFont', font);
        changeCustomizeValue('characterName', name);
        var currentLang = langChecker(state.customize.characterFont);
        var clickedLang = langChecker(font);
        var currentText = state.customize.characterText;
        var handleJa = function handleJa(jaFont, jaText) {
          if (jaFont === 'font-kosugi') {
            changeCustomizeValue('characterText', kataToHira(jaText));
          } else if (jaFont === 'font-noto') {
            changeCustomizeValue('characterText', hiraTokata(jaText));
          }
        };

        // en => en, cache(en)
        // ja => ja, cache(en), display(hira => kata or kata => hira)
        // en => ja, cache(en), display(cachedja)-> ja => ja
        // ja => en, cache(ja), display(cacheden)
        if (currentLang === 'EN' && clickedLang === 'EN') {
          setLangCache(_objectSpread(_objectSpread({}, langCache), {}, {
            EN: currentText
          }));
        } else if (currentLang === 'JA' && clickedLang === 'JA') {
          handleJa(font, currentText);
          setLangCache(_objectSpread(_objectSpread({}, langCache), {}, {
            JA: currentText
          }));
        } else if (currentLang === 'EN' && clickedLang === 'JA') {
          handleJa(font, langCache.JA);
          setLangCache(_objectSpread(_objectSpread({}, langCache), {}, {
            EN: currentText
          }));
        } else if (currentLang === 'JA' && clickedLang === 'EN') {
          changeCustomizeValue('characterText', langCache.EN);
          setLangCache(_objectSpread(_objectSpread({}, langCache), {}, {
            JA: currentText
          }));
        }
      },
      selected: state.customize.characterId === characterId
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("p", {
      className: "".concat(font, " 2xl:text-3xl md:text-2xl text-xl")
    }, word)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement(_common_UnderCellText__WEBPACK_IMPORTED_MODULE_9__.UnderCellText, {
      text: name
    }));
  }));
};

/***/ }),

/***/ "./src/ts/components/product/CustomizeCharacterSize.tsx":
/*!**************************************************************!*\
  !*** ./src/ts/components/product/CustomizeCharacterSize.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CustomizeCharacterSize": () => (/* binding */ CustomizeCharacterSize)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _hooks_useChangeCustomizeValue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../hooks/useChangeCustomizeValue */ "./src/ts/hooks/useChangeCustomizeValue.tsx");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var _CustomizeCell__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./CustomizeCell */ "./src/ts/components/product/CustomizeCell.tsx");
/* harmony import */ var _utils_type_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/type.helper */ "./src/ts/utils/type.helper.ts");
/* harmony import */ var _common_QuestionMark__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../common/QuestionMark */ "./src/ts/components/common/QuestionMark.tsx");






var CustomizeCharacterSize = function CustomizeCharacterSize() {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_2__.ProductContext),
    state = _useContext.productState,
    dispatch = _useContext.productDispatch;
  var changeCustomizeValue = (0,_hooks_useChangeCustomizeValue__WEBPACK_IMPORTED_MODULE_1__.useChangeCustomizeValue)(dispatch);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "grid grid-cols-4"
  }, _utils_type_helper__WEBPACK_IMPORTED_MODULE_4__.character.sizes.map(function (size, index) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_CustomizeCell__WEBPACK_IMPORTED_MODULE_3__.CustomizeCell, {
      key: size,
      onClick: function onClick() {
        changeCustomizeValue('characterSize', size);
      },
      selected: state.customize.characterSize === size,
      style: "".concat(!index ? 'col-start-1 col-end-5' : '')
    }, size);
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_common_QuestionMark__WEBPACK_IMPORTED_MODULE_5__.QuestionMark, {
    text: "\u5546\u54C1\u5225\u304A\u3059\u3059\u3081\u30B5\u30A4\u30BA"
  }));
};

/***/ }),

/***/ "./src/ts/components/product/CustomizeCharacterText.tsx":
/*!**************************************************************!*\
  !*** ./src/ts/components/product/CustomizeCharacterText.tsx ***!
  \**************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CustomizeCharacterText": () => (/* binding */ CustomizeCharacterText)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _hooks_useCharText__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../hooks/useCharText */ "./src/ts/hooks/useCharText.tsx");
/* harmony import */ var _utils_TEXT__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/TEXT */ "./src/ts/utils/TEXT.ts");
/* harmony import */ var _common_WarningText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../common/WarningText */ "./src/ts/components/common/WarningText.tsx");




var CustomizeCharacterText = function CustomizeCharacterText() {
  var _useCharText = (0,_hooks_useCharText__WEBPACK_IMPORTED_MODULE_1__.useCharText)(),
    text = _useCharText.text,
    currentCount = _useCharText.currentCount,
    totalCount = _useCharText.totalCount,
    errorMsg = _useCharText.errorMsg,
    handleTextChange = _useCharText.handleTextChange,
    handleCompositionEnd = _useCharText.handleCompositionEnd,
    handleCompositionStart = _useCharText.handleCompositionStart,
    handleFocus = _useCharText.handleFocus,
    color = _useCharText.color;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "mx-1 lg:mx-3 md:mx-2"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_common_WarningText__WEBPACK_IMPORTED_MODULE_3__.WarningText, null, _utils_TEXT__WEBPACK_IMPORTED_MODULE_2__["default"].PRODUCT.CUSTOMIZE.CHAR_TEXT_WARNING), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "relative mt-2 lg:mt-4 lg:h-12"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", {
    type: "text",
    style: {
      color: color
    },
    className: "w-full h-full font-medium t-input-box",
    value: text,
    onChange: handleTextChange,
    onLoad: handleTextChange,
    onCompositionEnd: handleCompositionEnd,
    onCompositionStart: handleCompositionStart,
    onFocus: handleFocus
  }), errorMsg && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "text-xs text-center text-red-600 mt-2"
  }, errorMsg), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "absolute right-2.5 text-base text-towel-product-gray-middle",
    style: {
      top: '50%',
      transform: 'translateY(-50%)'
    }
  }, "".concat(currentCount, " / ").concat(totalCount)))));
};

/***/ }),

/***/ "./src/ts/components/product/CustomizeContent.tsx":
/*!********************************************************!*\
  !*** ./src/ts/components/product/CustomizeContent.tsx ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var _CustomizeCharacterColor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./CustomizeCharacterColor */ "./src/ts/components/product/CustomizeCharacterColor.tsx");
/* harmony import */ var _CustomizeCharacterFont__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./CustomizeCharacterFont */ "./src/ts/components/product/CustomizeCharacterFont.tsx");
/* harmony import */ var _CustomizeCharacterSize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./CustomizeCharacterSize */ "./src/ts/components/product/CustomizeCharacterSize.tsx");
/* harmony import */ var _CustomizeCharacterText__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./CustomizeCharacterText */ "./src/ts/components/product/CustomizeCharacterText.tsx");
/* harmony import */ var _CustomizeHeader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./CustomizeHeader */ "./src/ts/components/product/CustomizeHeader.tsx");
/* harmony import */ var _CustomizeMotifLayout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./CustomizeMotifLayout */ "./src/ts/components/product/CustomizeMotifLayout.tsx");
/* harmony import */ var _CustomizePosition__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./CustomizePosition */ "./src/ts/components/product/CustomizePosition.tsx");
/* harmony import */ var _CustomizeMotifSelection__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./CustomizeMotifSelection */ "./src/ts/components/product/CustomizeMotifSelection.tsx");
/* harmony import */ var _CustomizeShowType__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./CustomizeShowType */ "./src/ts/components/product/CustomizeShowType.tsx");
/* harmony import */ var _CustomizePreviewMotif__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./CustomizePreviewMotif */ "./src/ts/components/product/CustomizePreviewMotif.tsx");
/* harmony import */ var _CustomizePreviewPosition__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./CustomizePreviewPosition */ "./src/ts/components/product/CustomizePreviewPosition.tsx");
/* harmony import */ var _utils_TEXT__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../utils/TEXT */ "./src/ts/utils/TEXT.ts");
/* harmony import */ var _TopButtonGroups__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./TopButtonGroups */ "./src/ts/components/product/TopButtonGroups.tsx");















var CustomizeSteps = /*#__PURE__*/function (CustomizeSteps) {
  CustomizeSteps[CustomizeSteps["CustomizeShowTypeIndex"] = 0] = "CustomizeShowTypeIndex";
  CustomizeSteps[CustomizeSteps["CustomizeCharacterFontIndex"] = 1] = "CustomizeCharacterFontIndex";
  CustomizeSteps[CustomizeSteps["CustomizeCharacterColorIndex"] = 2] = "CustomizeCharacterColorIndex";
  CustomizeSteps[CustomizeSteps["CustomizeCharacterTextIndex"] = 3] = "CustomizeCharacterTextIndex";
  CustomizeSteps[CustomizeSteps["CustomizeCharacterSizeIndex"] = 4] = "CustomizeCharacterSizeIndex";
  CustomizeSteps[CustomizeSteps["CustomizeMotifSelectionIndex"] = 5] = "CustomizeMotifSelectionIndex";
  CustomizeSteps[CustomizeSteps["CustomizeMotifLayoutIndex"] = 6] = "CustomizeMotifLayoutIndex";
  CustomizeSteps[CustomizeSteps["CustomizePositionIndex"] = 7] = "CustomizePositionIndex";
  return CustomizeSteps;
}(CustomizeSteps || {});
var CustomizeContent = function CustomizeContent() {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_1__.ProductContext),
    state = _useContext.productState;
  var steps = [{
    title: _utils_TEXT__WEBPACK_IMPORTED_MODULE_13__["default"].PRODUCT.CUSTOMIZE.SHOW_TYPE,
    component: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_CustomizeShowType__WEBPACK_IMPORTED_MODULE_10__.CustomizeShowType, null)
  }, {
    title: _utils_TEXT__WEBPACK_IMPORTED_MODULE_13__["default"].PRODUCT.CUSTOMIZE.CHAR_FONT,
    component: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_CustomizeCharacterFont__WEBPACK_IMPORTED_MODULE_3__.CustomizeCharacterFont, null)
  }, {
    title: _utils_TEXT__WEBPACK_IMPORTED_MODULE_13__["default"].PRODUCT.CUSTOMIZE.CHAR_COLOR,
    component: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_CustomizeCharacterColor__WEBPACK_IMPORTED_MODULE_2__.CustomizeCharacterColor, null)
  }, {
    title: _utils_TEXT__WEBPACK_IMPORTED_MODULE_13__["default"].PRODUCT.CUSTOMIZE.CHAR_TEXT,
    component: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_CustomizeCharacterText__WEBPACK_IMPORTED_MODULE_5__.CustomizeCharacterText, null)
  }, {
    title: _utils_TEXT__WEBPACK_IMPORTED_MODULE_13__["default"].PRODUCT.CUSTOMIZE.CHAR_SIZE,
    component: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_CustomizeCharacterSize__WEBPACK_IMPORTED_MODULE_4__.CustomizeCharacterSize, null)
  }, {
    title: _utils_TEXT__WEBPACK_IMPORTED_MODULE_13__["default"].PRODUCT.CUSTOMIZE.MOTIF_SELECT,
    component: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_CustomizeMotifSelection__WEBPACK_IMPORTED_MODULE_9__.CustomizeMotifSelection, null)
  }, {
    title: _utils_TEXT__WEBPACK_IMPORTED_MODULE_13__["default"].PRODUCT.CUSTOMIZE.MOTIF_LAYOUT,
    component: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_CustomizeMotifLayout__WEBPACK_IMPORTED_MODULE_7__.CustomizeMotifLayout, null)
  }, {
    title: _utils_TEXT__WEBPACK_IMPORTED_MODULE_13__["default"].PRODUCT.CUSTOMIZE.MOTIF_POSITION,
    component: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_CustomizePosition__WEBPACK_IMPORTED_MODULE_8__.CustomizePosition, null)
  }];
  var handleDisable = function handleDisable(type, index) {
    if (type === 1 || !index) {
      return false;
    } else if (type === 0) {
      return [CustomizeSteps.CustomizeMotifSelectionIndex, CustomizeSteps.CustomizeMotifLayoutIndex].includes(index);
    } else {
      return ![CustomizeSteps.CustomizeMotifSelectionIndex, CustomizeSteps.CustomizePositionIndex].includes(index);
    }
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    id: "t-product-towel-customization",
    className: "__product_customize select-none font-medium text-xl text-black ".concat(state.panelOpen ? '' : 'hidden').trim()
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("h1", {
    className: "py-3 mt-8 text-xl text-center border-b lg:py-5 lg:mt-16 lg:text-2xl border-towel-text"
  }, _utils_TEXT__WEBPACK_IMPORTED_MODULE_13__["default"].PRODUCT.CUSTOMIZE.TITLE), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex flex-col-reverse justify-between mt-10 lg:flex-row"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "w-full lg:mx-6 lg:w-1/2 __product_customize_preview"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "sticky z-10 top-0 text-lg text-center lg:text-left lg:text-xl"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_CustomizePreviewMotif__WEBPACK_IMPORTED_MODULE_11__.CustomizePreviewMotif, null), state.preview.isPreviewable && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_CustomizePreviewPosition__WEBPACK_IMPORTED_MODULE_12__.CustomizePreviewPosition, null))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "w-full lg:w-1/2 lg:mx-6"
  }, steps.map(function (_ref, index) {
    var title = _ref.title,
      component = _ref.component;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_CustomizeHeader__WEBPACK_IMPORTED_MODULE_6__.CustomizeHeader, {
      key: title,
      index: index + 1,
      title: title,
      disable: handleDisable(state.customize.showType, index)
    }, component);
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TopButtonGroups__WEBPACK_IMPORTED_MODULE_14__.TopButtonGroups, {
    showRight: false
  })));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CustomizeContent);

/***/ }),

/***/ "./src/ts/components/product/CustomizeHeader.tsx":
/*!*******************************************************!*\
  !*** ./src/ts/components/product/CustomizeHeader.tsx ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CustomizeHeader": () => (/* binding */ CustomizeHeader)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");

var CustomizeHeader = function CustomizeHeader(_ref) {
  var title = _ref.title,
    children = _ref.children,
    index = _ref.index,
    disable = _ref.disable;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "relative lg:mb-6 mb-3 ".concat(disable && index !== 4 ? 'opacity-50' : '').trim()
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex items-center justify-start mb-3 lg:mb-6"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("h1", {
    className: "flex items-center justify-center w-10 h-10 text-white bg-wine ".concat(disable && index === 4 ? 'opacity-50' : '').trim()
  }, index), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("h1", {
    className: "ml-2 text-base select-text lg:ml-4 lg:text-lg ".concat(disable && index === 4 ? 'opacity-50' : '').trim()
  }, title)), children, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "absolute cursor-not-allowed h-full top-0 w-full ".concat(disable ? '' : 'hidden', " ").trim()
  }));
};

/***/ }),

/***/ "./src/ts/components/product/CustomizeMotifLayout.tsx":
/*!************************************************************!*\
  !*** ./src/ts/components/product/CustomizeMotifLayout.tsx ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CustomizeMotifLayout": () => (/* binding */ CustomizeMotifLayout)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _hooks_useChangeCustomizeValue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../hooks/useChangeCustomizeValue */ "./src/ts/hooks/useChangeCustomizeValue.tsx");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var _CustomizeCell__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./CustomizeCell */ "./src/ts/components/product/CustomizeCell.tsx");
/* harmony import */ var _utils_type_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/type.helper */ "./src/ts/utils/type.helper.ts");
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/constants */ "./src/ts/utils/constants.ts");
/* harmony import */ var _common_UnderCellText__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../common/UnderCellText */ "./src/ts/components/common/UnderCellText.tsx");
/* harmony import */ var _common_CustomizeImg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../common/CustomizeImg */ "./src/ts/components/common/CustomizeImg.tsx");
/* harmony import */ var _common_WarningText__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../common/WarningText */ "./src/ts/components/common/WarningText.tsx");
/* harmony import */ var _utils_TEXT__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../utils/TEXT */ "./src/ts/utils/TEXT.ts");










var CustomizeMotifLayout = function CustomizeMotifLayout() {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_2__.ProductContext),
    state = _useContext.productState,
    dispatch = _useContext.productDispatch;
  var changeCustomizeValue = (0,_hooks_useChangeCustomizeValue__WEBPACK_IMPORTED_MODULE_1__.useChangeCustomizeValue)(dispatch);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_common_WarningText__WEBPACK_IMPORTED_MODULE_8__.WarningText, {
    red: false
  }, _utils_TEXT__WEBPACK_IMPORTED_MODULE_9__["default"].PRODUCT.CUSTOMIZE.WARNING), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "grid grid-cols-4 text-base"
  }, _utils_type_helper__WEBPACK_IMPORTED_MODULE_4__.motif.layouts.map(function (layout, index) {
    return !index ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "col-start-1 col-end-5",
      key: layout.name
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_CustomizeCell__WEBPACK_IMPORTED_MODULE_3__.CustomizeCell, {
      onClick: function onClick() {
        changeCustomizeValue('motifLayout', layout.name);
      },
      selected: state.customize.motifLayout === layout.name
    }, layout.name)) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      key: layout.name
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_CustomizeCell__WEBPACK_IMPORTED_MODULE_3__.CustomizeCell, {
      onClick: function onClick() {
        changeCustomizeValue('motifLayout', layout.name);
      },
      selected: state.customize.motifLayout === layout.name,
      isImage: true
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_common_CustomizeImg__WEBPACK_IMPORTED_MODULE_7__.CustomizeImg, {
      src: "".concat(_utils_constants__WEBPACK_IMPORTED_MODULE_5__.BASE_ASSET_URL, "/layout-").concat(layout.src, ".jpg"),
      alt: layout.name
    })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_common_UnderCellText__WEBPACK_IMPORTED_MODULE_6__.UnderCellText, {
      text: layout.name
    }));
  })));
};

/***/ }),

/***/ "./src/ts/components/product/CustomizeMotifSelection.tsx":
/*!***************************************************************!*\
  !*** ./src/ts/components/product/CustomizeMotifSelection.tsx ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CustomizeMotifSelection": () => (/* binding */ CustomizeMotifSelection)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _hooks_useMotifCategoriesQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../hooks/useMotifCategoriesQuery */ "./src/ts/hooks/useMotifCategoriesQuery.tsx");
/* harmony import */ var _utils_TEXT__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/TEXT */ "./src/ts/utils/TEXT.ts");
/* harmony import */ var _common_Spinner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../common/Spinner */ "./src/ts/components/common/Spinner.tsx");
/* harmony import */ var _MotifCategoryHeader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./MotifCategoryHeader */ "./src/ts/components/product/MotifCategoryHeader.tsx");
/* harmony import */ var _MotifCell__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./MotifCell */ "./src/ts/components/product/MotifCell.tsx");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var _MotifModal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./MotifModal */ "./src/ts/components/product/MotifModal.tsx");
/* harmony import */ var _hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../hooks/useIsMobile */ "./src/ts/hooks/useIsMobile.tsx");







// import { LazyFactory } from '../common/LazyFactory';




// const MotifModal = lazy(() => import('./MotifModal'));

var CustomizeMotifSelection = function CustomizeMotifSelection() {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_7__.ProductContext),
    state = _useContext.productState;
  var isMobile = (0,_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_9__.useIsMobile)();
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}),
    _useState2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useState, 2),
    motif = _useState2[0],
    setMotif = _useState2[1];
  var num = 20;
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(Array.from({
      length: num
    }, function (_) {
      _;
      return {
        open: false,
        fetched: false,
        samples: [{
          id: '',
          photo: {
            url: ''
          },
          name: ''
        }]
      };
    })),
    _useState4 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useState3, 2),
    opens = _useState4[0],
    setOpens = _useState4[1];
  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
    _useState6 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useState5, 2),
    openModal = _useState6[0],
    setOpenModal = _useState6[1];
  var _useMotifCategoriesQu = (0,_hooks_useMotifCategoriesQuery__WEBPACK_IMPORTED_MODULE_2__.useMotifCategoriesQuery)(num, state.motifParentCategory, state.preview.disabledMotifCategory),
    categories = _useMotifCategoriesQu.data,
    error = _useMotifCategoriesQu.error,
    isFetching = _useMotifCategoriesQu.isFetching;
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var _targetContent$datase, _targetContent$datase2, _targetContent$datase3;
    var targetContent = document.querySelector('#t-ts-product-detail');
    if (!targetContent) {
      return;
    }
    setMotif({
      motifCount: parseInt((_targetContent$datase = targetContent.dataset.motifCount) !== null && _targetContent$datase !== void 0 ? _targetContent$datase : "0"),
      motifHint: (_targetContent$datase2 = targetContent.dataset.motifHint) !== null && _targetContent$datase2 !== void 0 ? _targetContent$datase2 : '',
      motifText: (_targetContent$datase3 = targetContent.dataset.motifText) !== null && _targetContent$datase3 !== void 0 ? _targetContent$datase3 : ''
    });
  }, []);
  var handleOpen = function handleOpen(index) {
    setOpenModal(true);
    if (typeof index === 'number') {
      var toTargetCategory = setInterval(function () {
        var category = document.querySelector(".js-motif-category-".concat(index));
        var moreBtn = document.querySelector(".js-motif-category-".concat(index, " button"));
        if (moreBtn) {
          moreBtn.click();
        }
        if (category) {
          category.scrollIntoView({
            behavior: 'smooth'
          });
          clearInterval(toTargetCategory);
        }
      }, 500);
    }
  };
  if (error) return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("span", null, "error");
  var targetContent = document.querySelector('#t-ts-product-detail');
  var motifCount = 0;
  var motifText = '';
  if (targetContent && targetContent.dataset.motifCount) {
    motifCount = parseInt(targetContent.dataset.motifCount);
  }
  if (targetContent && targetContent.dataset.motifText) {
    motifText = targetContent.dataset.motifText;
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "relative mx-1 text-lg lg:mx-3 md:mx-2"
  }, state.motifParentCategory !== 'tmm' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("p", {
    className: "text-sm mb-4"
  }, motif.motifHint), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("p", {
    onClick: function onClick() {
      return handleOpen();
    },
    className: "flex items-center justify-center p-3 border-solid border-gray-300 border mb-5 text-xs border-b cursor-pointer lg:text-sm r-0 ".concat(isMobile ? 'h-15' : 'h-20')
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("img", {
    src: "//cdn.shopify.com/s/files/1/0487/6795/9189/t/69/assets/t-icon-search.svg?v=148230794486831944331643767000",
    alt: "",
    className: "h-6 w-6"
  }), "\u30E2\u30C1\u30FC\u30D5\u3092\u691C\u7D22\u3059\u308B"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("p", {
    className: "text-sm mb-4"
  }, motif.motifText)), isFetching ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_common_Spinner__WEBPACK_IMPORTED_MODULE_4__.Spinner, {
    color: "#000"
  }) : categories === null || categories === void 0 ? void 0 : categories.map(function (category, index) {
    if (index + 1 > +motif.motifCount) return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null);
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      key: category.name
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_MotifCategoryHeader__WEBPACK_IMPORTED_MODULE_5__.MotifCategoryHeader, {
      opens: opens,
      setOpens: setOpens,
      index: index,
      category: category,
      close: true,
      motifParentCategory: state.motifParentCategory
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      className: "w-full bg-gray-100 border border-gray-300 top-24 grid grid-cols-3 gap-2 items-center md:p-6 p-1 ".concat(opens[index].open ? 'block' : 'hidden')
    }, opens[index].fetched && opens[index].samples.length !== 0 ? opens[index].samples.map(function (sample) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_MotifCell__WEBPACK_IMPORTED_MODULE_6__.MotifCell, {
        key: sample.name,
        motif: sample
      });
    }) : opens[index].fetched && opens[index].samples.length === 0 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      className: "t-no-motif-text text-sm md:text-base"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("p", null, _utils_TEXT__WEBPACK_IMPORTED_MODULE_3__["default"].PRODUCT.MOTIF.NO_MOTIF_TEXT1), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("p", null, _utils_TEXT__WEBPACK_IMPORTED_MODULE_3__["default"].PRODUCT.MOTIF.NO_MOTIF_TEXT2)) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      className: "col-start-2 place-self-center"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_common_Spinner__WEBPACK_IMPORTED_MODULE_4__.Spinner, {
      color: "#222",
      key: "".concat(index, "-spinner")
    })), opens[index].fetched && state.motifParentCategory !== 'tmm' && opens[index].samples.length !== 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("button", {
      onClick: function onClick() {
        return handleOpen(index);
      },
      className: "col-start-2 col-end-3 row-start-2 row-end-3 t-more-btn"
    }, _utils_TEXT__WEBPACK_IMPORTED_MODULE_3__["default"].COMMON.MORE)));
  })), state.motifParentCategory !== 'tmm' &&
  /*#__PURE__*/
  // <LazyFactory screen={false}>
  react__WEBPACK_IMPORTED_MODULE_1__.createElement(_MotifModal__WEBPACK_IMPORTED_MODULE_8__["default"], {
    openModal: openModal,
    setOpenModal: setOpenModal
  })
  // </LazyFactory>
  );
};

/***/ }),

/***/ "./src/ts/components/product/CustomizePosition.tsx":
/*!*********************************************************!*\
  !*** ./src/ts/components/product/CustomizePosition.tsx ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CustomizePosition": () => (/* binding */ CustomizePosition)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _hooks_useChangeCustomizeValue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../hooks/useChangeCustomizeValue */ "./src/ts/hooks/useChangeCustomizeValue.tsx");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var _CustomizeCell__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./CustomizeCell */ "./src/ts/components/product/CustomizeCell.tsx");
/* harmony import */ var _utils_type_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/type.helper */ "./src/ts/utils/type.helper.ts");
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/constants */ "./src/ts/utils/constants.ts");
/* harmony import */ var _common_UnderCellText__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../common/UnderCellText */ "./src/ts/components/common/UnderCellText.tsx");
/* harmony import */ var _common_CustomizeImg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../common/CustomizeImg */ "./src/ts/components/common/CustomizeImg.tsx");
/* harmony import */ var _utils_TEXT__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../utils/TEXT */ "./src/ts/utils/TEXT.ts");
/* harmony import */ var _common_WarningText__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../common/WarningText */ "./src/ts/components/common/WarningText.tsx");










var CustomizePosition = function CustomizePosition() {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_2__.ProductContext),
    state = _useContext.productState,
    dispatch = _useContext.productDispatch;
  var changeCustomizeValue = (0,_hooks_useChangeCustomizeValue__WEBPACK_IMPORTED_MODULE_1__.useChangeCustomizeValue)(dispatch);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_common_WarningText__WEBPACK_IMPORTED_MODULE_9__.WarningText, {
    red: false
  }, _utils_TEXT__WEBPACK_IMPORTED_MODULE_8__["default"].PRODUCT.CUSTOMIZE.WARNING), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "grid grid-cols-4"
  }, _utils_type_helper__WEBPACK_IMPORTED_MODULE_4__.embroPositions.map(function (_ref) {
    var _state$preview, _state$preview$positi;
    var name = _ref.name,
      id = _ref.id;
    if (!((_state$preview = state.preview) !== null && _state$preview !== void 0 && (_state$preview$positi = _state$preview.positions) !== null && _state$preview$positi !== void 0 && _state$preview$positi.includes(id))) return null;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      key: name
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_CustomizeCell__WEBPACK_IMPORTED_MODULE_3__.CustomizeCell, {
      onClick: function onClick() {
        changeCustomizeValue('position', name);
        changeCustomizeValue('positionId', id);
      },
      selected: state.customize.position === name,
      isImage: true
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_common_CustomizeImg__WEBPACK_IMPORTED_MODULE_7__.CustomizeImg, {
      src: "".concat(_utils_constants__WEBPACK_IMPORTED_MODULE_5__.BASE_ASSET_URL, "/position_").concat(id, ".jpg").replace('centerCenter', 'omakase'),
      alt: name
    })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_common_UnderCellText__WEBPACK_IMPORTED_MODULE_6__.UnderCellText, {
      text: name
    }));
  })));
};

/***/ }),

/***/ "./src/ts/components/product/CustomizePreviewMotif.tsx":
/*!*************************************************************!*\
  !*** ./src/ts/components/product/CustomizePreviewMotif.tsx ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CustomizePreviewMotif": () => (/* binding */ CustomizePreviewMotif)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var _utils_TEXT__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/TEXT */ "./src/ts/utils/TEXT.ts");
/* harmony import */ var _MotifPreviewWindow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./MotifPreviewWindow */ "./src/ts/components/product/MotifPreviewWindow.tsx");
/* harmony import */ var _hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../hooks/useIsMobile */ "./src/ts/hooks/useIsMobile.tsx");





var CustomizePreviewMotif = function CustomizePreviewMotif() {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_1__.ProductContext),
    state = _useContext.productState;
  var isMobile = (0,_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_4__.useIsMobile)();
  var header = document.querySelector('#shopify-section-t-header');
  var w = window.outerWidth;
  var headerHeight = 0 + 'px';
  if (header && w < 767) {
    headerHeight = header.clientHeight + 'px';
  }
  var styles = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return {
      outerClasses: "flex flex-col text-base items-center justify-around ".concat(isMobile && 'top-0 left-0 right-0 z-50 fixed invisible'),
      outerStyle: {
        height: state.preview.isPreviewable ? '25vh' : '50vh',
        backgroundColor: isMobile ? '#fff' : 'auto',
        top: headerHeight
      },
      divStyle: {
        outline: '1px solid gray',
        width: '100%',
        display: 'flex',
        // height: state.preview.isPreviewable ? '20vh' : '45vh',
        height: state.preview.isPreviewable ? '30vh' : '45vh',
        WhiteSpace: 'nowrap',
        padding: '2px',
        justifyContent: 'center'
      }
    };
  }, [state, isMobile]);
  var previewProps = {
    backgroundColor: state.currentVariant.color,
    width: '90%'
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    "data-wl-custom-motif-preview": true,
    className: styles.outerClasses,
    style: styles.outerStyle
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("h1", {
    className: "text-base select-text lg:text-lg"
  }, _utils_TEXT__WEBPACK_IMPORTED_MODULE_2__["default"].PRODUCT.CUSTOMIZE.PREVIEW_IMAGE), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    style: styles.divStyle
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_MotifPreviewWindow__WEBPACK_IMPORTED_MODULE_3__.MotifPreviewWindow, previewProps)));
};

/***/ }),

/***/ "./src/ts/components/product/CustomizePreviewPosition.tsx":
/*!****************************************************************!*\
  !*** ./src/ts/components/product/CustomizePreviewPosition.tsx ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CustomizePreviewPosition": () => (/* binding */ CustomizePreviewPosition)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var _utils_TEXT__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/TEXT */ "./src/ts/utils/TEXT.ts");
/* harmony import */ var _common_WarningText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../common/WarningText */ "./src/ts/components/common/WarningText.tsx");
/* harmony import */ var _MotifPreviewPositionWindow__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./MotifPreviewPositionWindow */ "./src/ts/components/product/MotifPreviewPositionWindow.tsx");
/* harmony import */ var _hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../hooks/useIsMobile */ "./src/ts/hooks/useIsMobile.tsx");
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/constants */ "./src/ts/utils/constants.ts");








var CustomizePreviewPosition = function CustomizePreviewPosition() {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_2__.ProductContext),
    state = _useContext.productState;
  var isMobile = (0,_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_6__.useIsMobile)();
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
      outerClasses: 'flex flex-col items-center justify-around',
      outerStyle: {
        height: isMobile ? "".concat(_utils_constants__WEBPACK_IMPORTED_MODULE_7__.PREVIEW_POSITION_HEIGHT, "px") : '75vh'
      },
      divStyle: {
        outline: '1px solid gray',
        width: '100%',
        display: 'flex',
        height: isMobile ? "".concat(_utils_constants__WEBPACK_IMPORTED_MODULE_7__.PREVIEW_POSITION_HEIGHT * 13 / 15, "px") : '65vh',
        justifyContent: 'center'
      },
      innerStyle: {
        width: '90%'
      }
    }),
    _useState2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useState, 1),
    styles = _useState2[0];
  var previewProps = {
    backgroundColor: state.currentVariant.color
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    "data-wl-custom-motif-position": true,
    className: styles.outerClasses,
    style: styles.outerStyle
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("h1", {
    className: "text-base select-text lg:text-lg"
  }, _utils_TEXT__WEBPACK_IMPORTED_MODULE_3__["default"].PRODUCT.CUSTOMIZE.PREVIEW_POSITION), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "text-xs t-preview-alert"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("p", null, _utils_TEXT__WEBPACK_IMPORTED_MODULE_3__["default"].PRODUCT.CUSTOMIZE.ALERT_PREVIEW_1, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("a", {
    onClick: function onClick(e) {
      e.preventDefault();
      window.location.reload();
    }
  }, _utils_TEXT__WEBPACK_IMPORTED_MODULE_3__["default"].PRODUCT.CUSTOMIZE.ALERT_PREVIEW_2), _utils_TEXT__WEBPACK_IMPORTED_MODULE_3__["default"].PRODUCT.CUSTOMIZE.ALERT_PREVIEW_3)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    style: styles.divStyle
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_MotifPreviewPositionWindow__WEBPACK_IMPORTED_MODULE_5__.MotifPreviewPositionWindow, previewProps)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_common_WarningText__WEBPACK_IMPORTED_MODULE_4__.WarningText, null, _utils_TEXT__WEBPACK_IMPORTED_MODULE_3__["default"].PRODUCT.CUSTOMIZE.PREVIEW_WARNING_1), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_common_WarningText__WEBPACK_IMPORTED_MODULE_4__.WarningText, null, _utils_TEXT__WEBPACK_IMPORTED_MODULE_3__["default"].PRODUCT.CUSTOMIZE.PREVIEW_WARNING_2), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_common_WarningText__WEBPACK_IMPORTED_MODULE_4__.WarningText, null, _utils_TEXT__WEBPACK_IMPORTED_MODULE_3__["default"].PRODUCT.CUSTOMIZE.PREVIEW_WARNING_3));
};

/***/ }),

/***/ "./src/ts/components/product/CustomizeShowType.tsx":
/*!*********************************************************!*\
  !*** ./src/ts/components/product/CustomizeShowType.tsx ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CustomizeShowType": () => (/* binding */ CustomizeShowType)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _hooks_useChangeCustomizeValue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../hooks/useChangeCustomizeValue */ "./src/ts/hooks/useChangeCustomizeValue.tsx");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var _utils_productActions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/productActions */ "./src/ts/utils/productActions.ts");
/* harmony import */ var _utils_type_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/type.helper */ "./src/ts/utils/type.helper.ts");
/* harmony import */ var _CustomizeCell__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./CustomizeCell */ "./src/ts/components/product/CustomizeCell.tsx");






var CustomizeShowType = function CustomizeShowType() {
  var types = ['文字のみ', '文字+モチーフ', 'モチーフのみ'];
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_2__.ProductContext),
    state = _useContext.productState,
    dispatch = _useContext.productDispatch;
  var changeCustomizeValue = (0,_hooks_useChangeCustomizeValue__WEBPACK_IMPORTED_MODULE_1__.useChangeCustomizeValue)(dispatch);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "grid grid-cols-3"
  }, types.map(function (type, index) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      key: type,
      className: "".concat(state.preview.onlyChar && index !== _utils_type_helper__WEBPACK_IMPORTED_MODULE_4__.ShowType.ONLY_CHAR ? 'cursor-not-allowed opacity-50 pointer-events-none' : '')
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_CustomizeCell__WEBPACK_IMPORTED_MODULE_5__.CustomizeCell, {
      onClick: function onClick() {
        return (0,_utils_productActions__WEBPACK_IMPORTED_MODULE_3__.handleShowTypeSelect)(changeCustomizeValue, index);
      },
      selected: state.customize.showType === index
    }, type));
  }));
};

/***/ }),

/***/ "./src/ts/components/product/HTMLGenerator.tsx":
/*!*****************************************************!*\
  !*** ./src/ts/components/product/HTMLGenerator.tsx ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HTMLGenerator": () => (/* binding */ HTMLGenerator)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");

var HTMLGenerator = function HTMLGenerator(_ref) {
  var html = _ref.html;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    Array.from(document.querySelectorAll('.towel-html-by-react')).forEach(function (ele) {
      Array.from(ele.querySelectorAll('a')).forEach(function (a) {
        a.style.textDecoration = 'underline';
      });
    });
  }, []);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "m-2 text-black whitespace-normal towel-html-by-react",
    dangerouslySetInnerHTML: {
      __html: html
    }
  });
};

/***/ }),

/***/ "./src/ts/components/product/MotifCategoryHeader.tsx":
/*!***********************************************************!*\
  !*** ./src/ts/components/product/MotifCategoryHeader.tsx ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MotifCategoryHeader": () => (/* binding */ MotifCategoryHeader)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../hooks/useIsMobile */ "./src/ts/hooks/useIsMobile.tsx");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/helpers */ "./src/ts/utils/helpers.ts");



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var MotifCategoryHeader = function MotifCategoryHeader(_ref) {
  var _category$image;
  var category = _ref.category,
    _ref$opens = _ref.opens,
    opens = _ref$opens === void 0 ? [] : _ref$opens,
    _ref$setOpens = _ref.setOpens,
    setOpens = _ref$setOpens === void 0 ? function () {
      return window;
    } : _ref$setOpens,
    close = _ref.close,
    index = _ref.index,
    motifParentCategory = _ref.motifParentCategory;
  var handleCategoryClick = /*#__PURE__*/function () {
    var _ref2 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().mark(function _callee(id, clickIndex) {
      var newOpens;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            newOpens = _objectSpread({}, opens);
            if (close) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            newOpens[clickIndex].open = !opens[clickIndex].open;
            setOpens(newOpens);
            if (opens[clickIndex].fetched) {
              _context.next = 8;
              break;
            }
            _context.next = 8;
            return getCategorySampleMotifs(id, clickIndex);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleCategoryClick(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var getCategorySampleMotifs = /*#__PURE__*/function () {
    var _ref3 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().mark(function _callee2(sampleCategory, sampleIndex) {
      var params, _yield$MotifAxios$get, data, newOpens;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            params = {
              filters: "category[equals]".concat(sampleCategory, "[and]parentCategoryId[contains]").concat(motifParentCategory, "[and]shouldHide[equals]false"),
              fields: 'id,name,photo,illustration',
              limit: motifParentCategory === 'tmm' ? 400 : 3,
              order: '-updatedAt'
            };
            _context2.next = 3;
            return _utils_helpers__WEBPACK_IMPORTED_MODULE_5__.MotifAxios.get('/icons', {
              params: params
            });
          case 3:
            _yield$MotifAxios$get = _context2.sent;
            data = _yield$MotifAxios$get.data;
            newOpens = _objectSpread({}, opens);
            newOpens[sampleIndex].fetched = true;
            newOpens[sampleIndex].samples = data.contents;
            setOpens(newOpens);
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getCategorySampleMotifs(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  var isMobile = (0,_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_4__.useIsMobile)();
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
    onClick: function onClick() {
      return handleCategoryClick(category.id, index);
    },
    className: "flex items-center justify-between border border-gray-300 cursor-pointer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
    className: "flex items-center justify-start"
  }, category.image && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("img", {
    src: (category === null || category === void 0 ? void 0 : (_category$image = category.image) === null || _category$image === void 0 ? void 0 : _category$image.url) + "?w=".concat(isMobile ? '60' : '80'),
    alt: category.name,
    draggable: "false",
    className: "mx-5",
    width: isMobile ? '60' : '80',
    height: isMobile ? '60' : '80'
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("p", {
    className: "text-sm font-normal lg:text-base"
  }, category.name)), close && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("span", {
    className: "mr-5 transition-all duration-700 ".concat(opens[index].open ? 'transform rotate-45' : '', " lg:text-4xl text-3xl font-medium cursor-pointer md:font-extralight")
  }, "+"));
};

/***/ }),

/***/ "./src/ts/components/product/MotifCell.tsx":
/*!*************************************************!*\
  !*** ./src/ts/components/product/MotifCell.tsx ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MotifCell": () => (/* binding */ MotifCell)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/constants */ "./src/ts/utils/constants.ts");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/helpers */ "./src/ts/utils/helpers.ts");
/* harmony import */ var _hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../hooks/useIsMobile */ "./src/ts/hooks/useIsMobile.tsx");







var MotifCell = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.memo(function (_ref) {
  var _motif$photo, _motif$illustration;
  var motif = _ref.motif;
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_4__.ProductContext),
    state = _useContext.productState,
    dispatch = _useContext.productDispatch;
  var getOneMotif = /*#__PURE__*/function () {
    var _ref2 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(id) {
      var _data$name, _data$illustration$ur, _data$illustration, params, _yield$MotifAxios$get, data;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            params = {
              fields: 'id,ichihiroId,shopifyId,name,illustration,size'
            };
            _context.next = 4;
            return _utils_helpers__WEBPACK_IMPORTED_MODULE_5__.MotifAxios.get("/icons/".concat(id), {
              params: params
            });
          case 4:
            _yield$MotifAxios$get = _context.sent;
            data = _yield$MotifAxios$get.data;
            dispatch({
              type: _utils_constants__WEBPACK_IMPORTED_MODULE_3__.ProductPage.FETCH_ONE_MOTIF,
              id: id,
              ichihiroId: data.ichihiroId,
              size: data.size ? data.size[0] : 'M',
              name: (_data$name = data.name) !== null && _data$name !== void 0 ? _data$name : '',
              shopifyId: data.shopifyId,
              path: (_data$illustration$ur = (_data$illustration = data.illustration) === null || _data$illustration === void 0 ? void 0 : _data$illustration.url) !== null && _data$illustration$ur !== void 0 ? _data$illustration$ur : ''
            });
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](0);
            /* eslint no-console: ["error", { allow: ["warn", "error"] }] */
            console.error({
              error: _context.t0
            });
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 9]]);
    }));
    return function getOneMotif(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var isMobile = (0,_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_6__.useIsMobile)();
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
    className: "md:px-5 transition h-full duration-500 ease-in-out ring-inset p-2 w-full md:pt-5 bg-white\n      ".concat(state.customize.motifId === motif.id ? 'md:ring-6 ring-4 ring-wine' : 'ring-1 ring-gray-200', "  cursor-pointer"),
    onClick: function onClick() {
      getOneMotif(motif.id);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("p", {
    className: "text-xs text-center md:text-sm text-towel-product-gray-dark"
  }, motif.name), motif.photo ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("img", {
    src: ((_motif$photo = motif.photo) === null || _motif$photo === void 0 ? void 0 : _motif$photo.url) + "?w=".concat(isMobile ? '60' : '150', "&h=").concat(isMobile ? '60' : '150'),
    alt: motif.name,
    className: "mx-auto",
    draggable: "false",
    loading: "lazy",
    width: isMobile ? '60' : '150',
    height: isMobile ? '60' : '150'
  }) : motif.illustration && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.createElement("img", {
    src: ((_motif$illustration = motif.illustration) === null || _motif$illustration === void 0 ? void 0 : _motif$illustration.url) + "?w=".concat(isMobile ? '60' : '150'),
    alt: motif.name,
    loading: "lazy",
    className: "mx-auto",
    draggable: "false",
    width: isMobile ? '60' : '150',
    height: isMobile ? '60' : '150'
  }));
});
MotifCell.displayName = 'MotifCell';

/***/ }),

/***/ "./src/ts/components/product/MotifContainerByCategory.tsx":
/*!****************************************************************!*\
  !*** ./src/ts/components/product/MotifContainerByCategory.tsx ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MotifContainerByCategory": () => (/* binding */ MotifContainerByCategory)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _hooks_useMotifsQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../hooks/useMotifsQuery */ "./src/ts/hooks/useMotifsQuery.tsx");
/* harmony import */ var _MotifCell__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./MotifCell */ "./src/ts/components/product/MotifCell.tsx");
/* harmony import */ var _hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../hooks/useIsMobile */ "./src/ts/hooks/useIsMobile.tsx");
/* harmony import */ var _utils_TEXT__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/TEXT */ "./src/ts/utils/TEXT.ts");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");







var MotifContainerByCategory = function MotifContainerByCategory(_ref) {
  var id = _ref.id,
    index = _ref.index;
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_6__.ProductContext),
    state = _useContext.productState;
  var isMobile = (0,_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_4__.useIsMobile)();
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
    _useState2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isMobile ? 3 : 5),
    _useState4 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useState3, 1),
    initNumber = _useState4[0];
  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initNumber),
    _useState6 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useState5, 2),
    total = _useState6[0],
    setTotal = _useState6[1];
  var _useMotifsQuery = (0,_hooks_useMotifsQuery__WEBPACK_IMPORTED_MODULE_2__.useMotifsQuery)(id, total, true, state.motifParentCategory),
    data = _useMotifsQuery.data;
  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
      motifs: [],
      total: 0
    }),
    _useState8 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useState7, 2),
    motifs = _useState8[0],
    setMotifs = _useState8[1];
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (data) {
      setMotifs(data);
    }
  }, [data]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "w-full p-2 bg-gray-100 border border-gray-300 md:p-6 top-24"
  }, (motifs === null || motifs === void 0 ? void 0 : motifs.motifs.length) !== 0 ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "grid justify-items-center ".concat(isMobile ? 'grid-cols-3 gap-2' : 'grid-cols-5 gap-3')
  }, motifs === null || motifs === void 0 ? void 0 : motifs.motifs.map(function (motif, cellIndex) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_MotifCell__WEBPACK_IMPORTED_MODULE_3__.MotifCell, {
      key: "".concat(motif.name, "-").concat(cellIndex),
      motif: motif
    });
  })) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "text-center text-sm md:text-base"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("p", null, _utils_TEXT__WEBPACK_IMPORTED_MODULE_5__["default"].PRODUCT.MOTIF.NO_MOTIF_TEXT1), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("p", null, _utils_TEXT__WEBPACK_IMPORTED_MODULE_5__["default"].PRODUCT.MOTIF.NO_MOTIF_TEXT2)), motifs.total > initNumber && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("button", {
    onClick: function onClick() {
      if (!isOpen) {
        // open
        setTimeout(function () {
          setIsOpen(true);
        }, 1000);
        if (total === initNumber) {
          // first open
          setTotal(motifs.total);
        } else {
          var _data$motifs;
          // not first open
          setMotifs({
            total: motifs.total,
            motifs: (_data$motifs = data === null || data === void 0 ? void 0 : data.motifs) !== null && _data$motifs !== void 0 ? _data$motifs : []
          });
        }
      } else {
        var _data$motifs$slice;
        // close
        setIsOpen(false);
        setMotifs({
          total: motifs.total,
          motifs: (_data$motifs$slice = data === null || data === void 0 ? void 0 : data.motifs.slice(0, initNumber)) !== null && _data$motifs$slice !== void 0 ? _data$motifs$slice : []
        });
        document.querySelector(".js-motif-category-".concat(index)).scrollIntoView();
      }
    },
    className: "t-more-btn"
  }, isOpen ? _utils_TEXT__WEBPACK_IMPORTED_MODULE_5__["default"].COMMON.HIDE : _utils_TEXT__WEBPACK_IMPORTED_MODULE_5__["default"].COMMON.MORE)));
};

/***/ }),

/***/ "./src/ts/components/product/MotifList.tsx":
/*!*************************************************!*\
  !*** ./src/ts/components/product/MotifList.tsx ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MotifList": () => (/* binding */ MotifList)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/regenerator */ "./node_modules/@babel/runtime/regenerator/index.js");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _hooks_useMotifCategoriesQuery__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../hooks/useMotifCategoriesQuery */ "./src/ts/hooks/useMotifCategoriesQuery.tsx");
/* harmony import */ var _common_Spinner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../common/Spinner */ "./src/ts/components/common/Spinner.tsx");
/* harmony import */ var _MotifCategoryHeader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./MotifCategoryHeader */ "./src/ts/components/product/MotifCategoryHeader.tsx");
/* harmony import */ var _MotifContainerByCategory__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./MotifContainerByCategory */ "./src/ts/components/product/MotifContainerByCategory.tsx");
/* harmony import */ var _MotifResultContainer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./MotifResultContainer */ "./src/ts/components/product/MotifResultContainer.tsx");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../utils/helpers */ "./src/ts/utils/helpers.ts");
/* harmony import */ var _hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../hooks/useIsMobile */ "./src/ts/hooks/useIsMobile.tsx");
/* harmony import */ var _utils_TEXT__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../utils/TEXT */ "./src/ts/utils/TEXT.ts");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! react-query */ "./node_modules/react-query/es/index.js");
/* harmony import */ var _hooks_useDebounce__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../hooks/useDebounce */ "./src/ts/hooks/useDebounce.tsx");















var MotifList = function MotifList(_ref) {
  var _searchedMotifs$conte, _searchedMotifs$total;
  var handleClose = _ref.handleClose;
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_3__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_12__.ProductContext),
    state = _useContext.productState;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(''),
    _useState2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__["default"])(_useState, 2),
    query = _useState2[0],
    setQuery = _useState2[1];
  var isMobile = (0,_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_10__.useIsMobile)();
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
    _useState4 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__["default"])(_useState3, 2),
    isSearch = _useState4[0],
    setIsSearch = _useState4[1];
  var _useMotifCategoriesQu = (0,_hooks_useMotifCategoriesQuery__WEBPACK_IMPORTED_MODULE_4__.useMotifCategoriesQuery)(400, state.motifParentCategory, state.preview.disabledMotifCategory),
    categories = _useMotifCategoriesQu.data,
    isFetched = _useMotifCategoriesQu.isFetched;
  var debouncedQuery = (0,_hooks_useDebounce__WEBPACK_IMPORTED_MODULE_14__.useDebounce)(query.trim(), 1000);
  var _useQuery = (0,react_query__WEBPACK_IMPORTED_MODULE_13__.useQuery)([debouncedQuery], /*#__PURE__*/(0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().mark(function _callee() {
      var disabledMotifCategory, categoryParams, _yield$MotifAxios$get, categories, categorySearchString, disableString, motifParams, _yield$MotifAxios$get2, data;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            disabledMotifCategory = state.preview.disabledMotifCategory;
            categoryParams = {
              filters: "name[contains]".concat(debouncedQuery, "[and]parentCategory[contains]").concat(state.motifParentCategory),
              fields: 'id',
              limit: 400
            };
            _context.next = 4;
            return _utils_helpers__WEBPACK_IMPORTED_MODULE_9__.MotifAxios.get('/categories', {
              params: categoryParams
            });
          case 4:
            _yield$MotifAxios$get = _context.sent;
            categories = _yield$MotifAxios$get.data;
            categorySearchString = categories.totalCount > 0 ? categories.contents.map(function (category) {
              return '[or]category[equals]' + category.id;
            }).join('') : '';
            disableString = disabledMotifCategory ? disabledMotifCategory.map(function (category) {
              return '[and]category[not_equals]' + category;
            }).join('') : '';
            motifParams = {
              filters: "parentCategoryId[contains]".concat(state.motifParentCategory).concat(disableString, "[and](name[contains]").concat(debouncedQuery).concat(categorySearchString, ")[and]shouldHide[equals]false"),
              fields: 'id,name,photo,illustration',
              limit: 400
            };
            _context.next = 11;
            return _utils_helpers__WEBPACK_IMPORTED_MODULE_9__.MotifAxios.get('/icons', {
              params: motifParams
            });
          case 11:
            _yield$MotifAxios$get2 = _context.sent;
            data = _yield$MotifAxios$get2.data;
            return _context.abrupt("return", data);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), {
      enabled: isSearch,
      refetchOnMount: false
    }),
    searchedMotifs = _useQuery.data,
    searchIsFetching = _useQuery.isFetching,
    searchError = _useQuery.error;
  var handleMotifSearch = /*#__PURE__*/function () {
    var _ref3 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().mark(function _callee2(e) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            e.preventDefault();
            if (!query) {
              setIsSearch(false);
            }
            setIsSearch(true);
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleMotifSearch(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
    className: "sticky top-0 flex items-center justify-center w-10 h-10 border cursor-pointer border-wine left-full md:right-5 m-0.5 bg-white pl-3p",
    onClick: handleClose
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
    className: "text-3xl text-center transform rotate-45"
  }, "+")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
    className: "w-11/12 mx-auto text-xl md:w-4/5"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("p", {
    className: "my-3 text-base md:mb-3 md:text-xl"
  }, _utils_TEXT__WEBPACK_IMPORTED_MODULE_11__["default"].PRODUCT.MOTIF.TITLE), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("form", {
    onSubmit: function onSubmit(e) {
      return handleMotifSearch(e);
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
    className: "flex items-center justify-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("input", {
    type: "search",
    className: "w-full h-10 md:h-16 t-input-box",
    value: query,
    onChange: function onChange(e) {
      setQuery(e.target.value);
      if (!e.target.value) {
        setIsSearch(false);
      }
    },
    placeholder: _utils_TEXT__WEBPACK_IMPORTED_MODULE_11__["default"].PRODUCT.MOTIF.PLACEHOLDER
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("button", {
    type: "submit",
    className: "w-24 h-10 text-base text-white md:text-lg md:w-32 md:h-16 active:ring-primary-200 bg-wine focus:outline-none h-18 hover:bg-primary-600 ring-2 ring-wine"
  }, _utils_TEXT__WEBPACK_IMPORTED_MODULE_11__["default"].PRODUCT.MOTIF.SEARCH))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
    className: "mt-5 md:mt-10 ring-2 ring-gray-200"
  }, isFetched && !isSearch ? categories === null || categories === void 0 ? void 0 : categories.map(function (category, index) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
      key: category.id,
      className: "js-motif-category-".concat(index)
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_MotifCategoryHeader__WEBPACK_IMPORTED_MODULE_6__.MotifCategoryHeader, {
      index: index,
      category: category,
      close: false,
      motifParentCategory: state.motifParentCategory
    }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_MotifContainerByCategory__WEBPACK_IMPORTED_MODULE_7__.MotifContainerByCategory, {
      id: category.id,
      index: index
    }));
  }) : isSearch && !searchIsFetching && !searchError ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_MotifResultContainer__WEBPACK_IMPORTED_MODULE_8__.MotifResultContainer, {
    motifs: (_searchedMotifs$conte = searchedMotifs === null || searchedMotifs === void 0 ? void 0 : searchedMotifs.contents) !== null && _searchedMotifs$conte !== void 0 ? _searchedMotifs$conte : [],
    total: (_searchedMotifs$total = searchedMotifs === null || searchedMotifs === void 0 ? void 0 : searchedMotifs.totalCount) !== null && _searchedMotifs$total !== void 0 ? _searchedMotifs$total : 0
  }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
    className: "flex justify-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3__.createElement(_common_Spinner__WEBPACK_IMPORTED_MODULE_5__.Spinner, {
    color: "#222",
    num: isMobile ? 50 : 150
  })))));
};

/***/ }),

/***/ "./src/ts/components/product/MotifModal.tsx":
/*!**************************************************!*\
  !*** ./src/ts/components/product/MotifModal.tsx ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react-modal */ "./node_modules/react-modal/lib/index.js");
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_modal__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _MotifList__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./MotifList */ "./src/ts/components/product/MotifList.tsx");
/* harmony import */ var _hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../hooks/useIsMobile */ "./src/ts/hooks/useIsMobile.tsx");




var MotifModal = function MotifModal(_ref) {
  var openModal = _ref.openModal,
    setOpenModal = _ref.setOpenModal;
  var isMobile = (0,_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_3__.useIsMobile)();
  var customStyles = {
    content: {
      top: isMobile ? '55%' : '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      overflow: 'scroll',
      height: isMobile ? '85%' : '90%',
      width: isMobile ? '90%' : '80%',
      padding: isMobile ? '0px' : '20px',
      transform: 'translate(-50%, -50%)'
    }
  };
  react_modal__WEBPACK_IMPORTED_MODULE_1___default().setAppElement('#t-ts-product-detail');
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement((react_modal__WEBPACK_IMPORTED_MODULE_1___default()), {
    isOpen: openModal,
    onRequestClose: function onRequestClose() {
      return setOpenModal(false);
    },
    closeTimeoutMS: 200,
    style: customStyles,
    contentLabel: "Motif Modal",
    onAfterOpen: function onAfterOpen() {
      return document.body.classList.add('overflow-y-hidden');
    },
    onAfterClose: function onAfterClose() {
      return document.body.classList.remove('overflow-y-hidden');
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_MotifList__WEBPACK_IMPORTED_MODULE_2__.MotifList, {
    handleClose: function handleClose() {
      return setOpenModal(false);
    }
  }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MotifModal);

/***/ }),

/***/ "./src/ts/components/product/MotifPreviewPositionWindow.tsx":
/*!******************************************************************!*\
  !*** ./src/ts/components/product/MotifPreviewPositionWindow.tsx ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MotifPreviewPositionWindow": () => (/* binding */ MotifPreviewPositionWindow)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _hooks_useProductDivData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../hooks/useProductDivData */ "./src/ts/hooks/useProductDivData.tsx");
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/constants */ "./src/ts/utils/constants.ts");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var _utils_type_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/type.helper */ "./src/ts/utils/type.helper.ts");
/* harmony import */ var _hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../hooks/useIsMobile */ "./src/ts/hooks/useIsMobile.tsx");
/* harmony import */ var _hooks_useFontColor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../hooks/useFontColor */ "./src/ts/hooks/useFontColor.tsx");
/* harmony import */ var _common_MotifPreviewCore__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../common/MotifPreviewCore */ "./src/ts/components/common/MotifPreviewCore.tsx");
/* harmony import */ var _svgs_Index__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./svgs/Index */ "./src/ts/components/product/svgs/Index.tsx");
/* harmony import */ var _utils_contexts_PreviewReducer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../utils/contexts/PreviewReducer */ "./src/ts/utils/contexts/PreviewReducer.tsx");











var MotifPreviewPositionWindow = function MotifPreviewPositionWindow(_ref) {
  var _motif$layouts$find;
  var backgroundColor = _ref.backgroundColor;
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_4__.ProductContext),
    state = _useContext.productState;
  var _useReducer = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(_utils_contexts_PreviewReducer__WEBPACK_IMPORTED_MODULE_10__.previewReducer, _utils_contexts_PreviewReducer__WEBPACK_IMPORTED_MODULE_10__.previewInitState),
    _useReducer2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useReducer, 2),
    previewState = _useReducer2[0],
    previewDispatch = _useReducer2[1];
  var previewContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  var artContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  var verticalBgRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  var horizontalBgRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  var _useProductDivData = (0,_hooks_useProductDivData__WEBPACK_IMPORTED_MODULE_2__.useProductDivData)(),
    type = _useProductDivData.type;
  var isMobile = (0,_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_6__.useIsMobile)();
  var color = (0,_hooks_useFontColor__WEBPACK_IMPORTED_MODULE_7__.useFontColor)();
  var _useMemo = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
      var _document$querySelect;
      var divData = JSON.parse(document.querySelector('#t-product-extra-data') ? (_document$querySelect = document.querySelector('#t-product-extra-data')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.innerHTML : 'null');
      var commonRatio = divData.commonRatio;
      var ratio = divData.ratio;
      return [commonRatio, ratio];
    }, []),
    _useMemo2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useMemo, 2),
    persistCommonRatio = _useMemo2[0],
    persistRatio = _useMemo2[1];
  var reComputeBasedOnImage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
    var _state$customize$posi, _verticalBgRef$curren, _verticalBgRef$curren2, _horizontalBgRef$curr, _horizontalBgRef$curr2, _verticalBgRef$curren5, _verticalBgRef$curren6, _horizontalBgRef$curr7, _horizontalBgRef$curr8, _artContainerRef$curr, _artContainerRef$curr2;
    var leftRightLoop = (_state$customize$posi = state.customize.positionId.split(/(?=[A-Z])/)[1]) === null || _state$customize$posi === void 0 ? void 0 : _state$customize$posi.toLocaleLowerCase();
    // .map((word) => word.toLowerCase()) as PositionArrayType;

    previewDispatch({
      type: 'change_position',
      payload: {
        previewContainer: {
          height: previewContainerRef.current.offsetHeight,
          width: previewContainerRef.current.offsetWidth
        },
        verticalBg: {
          height: (_verticalBgRef$curren = verticalBgRef.current) === null || _verticalBgRef$curren === void 0 ? void 0 : _verticalBgRef$curren.offsetHeight,
          width: (_verticalBgRef$curren2 = verticalBgRef.current) === null || _verticalBgRef$curren2 === void 0 ? void 0 : _verticalBgRef$curren2.offsetWidth
        },
        horizontalBg: {
          height: (_horizontalBgRef$curr = horizontalBgRef.current) === null || _horizontalBgRef$curr === void 0 ? void 0 : _horizontalBgRef$curr.offsetHeight,
          width: (_horizontalBgRef$curr2 = horizontalBgRef.current) === null || _horizontalBgRef$curr2 === void 0 ? void 0 : _horizontalBgRef$curr2.offsetWidth
        }
      }
    });
    if (leftRightLoop !== 'loop' && previewState.charAndMotif.fontSize) {
      var _verticalBgRef$curren3, _verticalBgRef$curren4, _horizontalBgRef$curr3, _horizontalBgRef$curr4;
      previewDispatch({
        type: 'change_font',
        payload: {
          previewContainer: {
            height: previewContainerRef.current.offsetHeight,
            width: previewContainerRef.current.offsetWidth
          },
          verticalBg: {
            height: (_verticalBgRef$curren3 = verticalBgRef.current) === null || _verticalBgRef$curren3 === void 0 ? void 0 : _verticalBgRef$curren3.offsetHeight,
            width: (_verticalBgRef$curren4 = verticalBgRef.current) === null || _verticalBgRef$curren4 === void 0 ? void 0 : _verticalBgRef$curren4.offsetWidth
          },
          horizontalBg: {
            height: (_horizontalBgRef$curr3 = horizontalBgRef.current) === null || _horizontalBgRef$curr3 === void 0 ? void 0 : _horizontalBgRef$curr3.offsetHeight,
            width: (_horizontalBgRef$curr4 = horizontalBgRef.current) === null || _horizontalBgRef$curr4 === void 0 ? void 0 : _horizontalBgRef$curr4.offsetWidth
          }
        }
      });
    } else {
      var _horizontalBgRef$curr5, _horizontalBgRef$curr6;
      previewDispatch({
        type: 'change_font',
        payload: {
          previewContainer: {
            height: previewContainerRef.current.offsetHeight,
            width: previewContainerRef.current.offsetWidth
          },
          verticalBg: {
            height: previewContainerRef.current.offsetHeight * 0.8,
            width: previewContainerRef.current.offsetWidth * 0.8
          },
          horizontalBg: {
            height: (_horizontalBgRef$curr5 = horizontalBgRef.current) === null || _horizontalBgRef$curr5 === void 0 ? void 0 : _horizontalBgRef$curr5.offsetHeight,
            width: (_horizontalBgRef$curr6 = horizontalBgRef.current) === null || _horizontalBgRef$curr6 === void 0 ? void 0 : _horizontalBgRef$curr6.offsetWidth
          }
        }
      });
    }
    previewDispatch({
      type: 'change_transform',
      payload: {
        previewContainer: {
          height: previewContainerRef.current.offsetHeight,
          width: previewContainerRef.current.offsetWidth
        },
        verticalBg: {
          height: (_verticalBgRef$curren5 = verticalBgRef.current) === null || _verticalBgRef$curren5 === void 0 ? void 0 : _verticalBgRef$curren5.offsetHeight,
          width: (_verticalBgRef$curren6 = verticalBgRef.current) === null || _verticalBgRef$curren6 === void 0 ? void 0 : _verticalBgRef$curren6.offsetWidth
        },
        horizontalBg: {
          height: (_horizontalBgRef$curr7 = horizontalBgRef.current) === null || _horizontalBgRef$curr7 === void 0 ? void 0 : _horizontalBgRef$curr7.offsetHeight,
          width: (_horizontalBgRef$curr8 = horizontalBgRef.current) === null || _horizontalBgRef$curr8 === void 0 ? void 0 : _horizontalBgRef$curr8.offsetWidth
        },
        artContainer: {
          height: (_artContainerRef$curr = artContainerRef.current) === null || _artContainerRef$curr === void 0 ? void 0 : _artContainerRef$curr.offsetHeight,
          width: (_artContainerRef$curr2 = artContainerRef.current) === null || _artContainerRef$curr2 === void 0 ? void 0 : _artContainerRef$curr2.offsetWidth
        },
        customize: {
          textLength: state.customize.characterText.length,
          motifLayout: state.customize.motifLayout,
          motifShow: state.customize.motifShow ? state.customize.motifShow : false,
          positionId: state.customize.positionId
        }
      }
    });
    if (type && state.panelOpen && (['WT', 'MHT', 'MLT', 'MT'].includes(type) || leftRightLoop === 'loop') && previewContainerRef.current.offsetHeight > previewContainerRef.current.offsetWidth) {
      previewDispatch({
        type: 'find_shape',
        payload: true
      });
    }
  }, [state.customize.characterText, state.customize.motifLayout, state.customize.motifShow, state.panelOpen, state.customize.positionId, previewState.charAndMotif.fontSize, type]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var _state$customize$moti;
    // ! position
    var _ref2 = state.customize.positionId.split(/(?=[A-Z])/).map(function (word) {
        return word.toLowerCase();
      }),
      _ref3 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_ref2, 4),
      topBottom = _ref3[0],
      leftRightLoop = _ref3[1],
      leaningLying = _ref3[2],
      lyingUndefined = _ref3[3];
    var position = {
      topBottom: topBottom,
      leftRightLoop: leftRightLoop,
      leaningLying: leaningLying,
      lyingUndefined: lyingUndefined,
      leaningTransform: '',
      artTop: '',
      artRight: '',
      artLeft: '',
      artBottom: '',
      transform: ''
    };
    // ! position

    //! charAndMotif
    var lang = state.customize.characterFont === 'font-kosugi' || state.customize.characterFont === 'font-noto' ? 'JA' : 'EN';
    var selectedFontSize = Number(state.customize.characterSize.includes('cm') ? state.customize.characterSize.replace('cm', '') : persistCommonRatio.DefaultFontSize);
    var charAndMotif = {
      lang: lang,
      selectedFontSize: selectedFontSize,
      fontSize: previewState.charAndMotif.fontSize,
      motifShowSize: previewState.charAndMotif.motifShowSize,
      motifSizeRatio: _utils_type_helper__WEBPACK_IMPORTED_MODULE_5__.motifSize[(_state$customize$moti = state.customize.motifSize) !== null && _state$customize$moti !== void 0 ? _state$customize$moti : 'M'].ratio,
      towelWidth: state.preview.width,
      jNumber: state.preview.jNumber,
      eNumber: state.preview.eNumber
    };
    //! charAndMotif

    //! bg
    var currentDirection = 'vertical';
    if (leftRightLoop === 'loop') {
      currentDirection = 'loop';
    } else if ([leaningLying, lyingUndefined].includes('lying')) {
      currentDirection = 'horizontal';
    }
    var possiblePositions = ['vertical'];
    if (state.preview.positions.some(function (pos) {
      return pos.includes('Loop');
    })) possiblePositions.push('loop');
    if (state.preview.positions.some(function (pos) {
      return pos.includes('Lying');
    })) possiblePositions.push('horizontal');
    var isSquareShape = false;
    var isSpecialShape = false;
    var verticalImageUrl = '';
    var horizontalImageUrl = '';
    if (type) {
      verticalImageUrl = "".concat(_utils_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSET_URL, "/preview__").concat(type, ".svg");
      horizontalImageUrl = "".concat(_utils_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSET_URL, "/preview__").concat(type, "_lying.svg");
      if (['WT', 'MHT', 'MLT', 'MT'].includes(type) || leftRightLoop === 'loop') {
        isSquareShape = true;
        if (previewContainerRef.current.offsetHeight > previewContainerRef.current.offsetWidth) {
          isSpecialShape = true;
        }
      }
    }
    var bg = {
      verticalImageUrl: verticalImageUrl,
      horizontalImageUrl: horizontalImageUrl,
      currentDirection: currentDirection,
      isSpecialShape: isSpecialShape,
      isSquareShape: isSquareShape,
      possiblePositions: possiblePositions
    };
    //! bg

    var payload = {
      meta: {
        type: type !== null && type !== void 0 ? type : '',
        isMobile: isMobile
      },
      position: position,
      charAndMotif: charAndMotif,
      bg: bg,
      ratio: persistRatio,
      commonRatio: persistCommonRatio
    };
    previewDispatch({
      type: 'assign_preview',
      payload: payload
    });
    reComputeBasedOnImage(); // dispatch: change_position
  }, [state.customize.positionId, state.customize.motifSize, state.customize.characterFont, state.customize.characterSize, state.preview.positions, state.preview.width, state.preview.eNumber, state.preview.jNumber, type, isMobile, persistCommonRatio, persistRatio, reComputeBasedOnImage, previewState.charAndMotif.fontSize, previewState.charAndMotif.motifShowSize, previewState.bg.currentDirection // ! necessary for re-locate when bg image changes
  ]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    ref: previewContainerRef,
    className: "relative flex items-center justify-center w-full"
  }, previewState.bg.possiblePositions.includes('loop') && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_svgs_Index__WEBPACK_IMPORTED_MODULE_9__.BgLoop, {
    backgroundColor: backgroundColor,
    onLoad: reComputeBasedOnImage // !new handle load function
    ,
    style: {
      position: 'absolute',
      display: previewState.bg.currentDirection === 'loop' ? 'block' : 'none',
      width: '100%',
      height: '100%'
    }
  }), previewState.bg.possiblePositions.includes('horizontal') && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("img", {
    src: previewState.bg.horizontalImageUrl,
    alt: "bg-image",
    ref: horizontalBgRef,
    onLoad: reComputeBasedOnImage // !new handle load function
    ,
    draggable: "false",
    style: {
      position: 'absolute',
      backgroundColor: backgroundColor,
      height: 'auto',
      width: '100%',
      display: previewState.bg.currentDirection === 'horizontal' ? 'block' : 'none'
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("img", {
    src: previewState.bg.verticalImageUrl,
    alt: "bg-image",
    ref: verticalBgRef,
    draggable: "false",
    onLoad: function onLoad() {
      var isAndroid = /android/i.test(navigator.userAgent || navigator.vendor);
      if (isAndroid && state.customize.positionId === 'centerCenter') {
        setTimeout(function () {
          reComputeBasedOnImage(); // dispatch: change_position
        }, 2000);
      } else {
        reComputeBasedOnImage(); // dispatch: change_position
      }
    } // !new handle load function
    ,
    style: {
      position: 'absolute',
      backgroundColor: backgroundColor,
      width: previewState.bg.isSpecialShape ? '100%' : 'auto',
      height: previewState.bg.isSpecialShape ? 'auto' : '100%',
      display: previewState.bg.currentDirection === 'vertical' ? 'block' : 'none'
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    ref: artContainerRef,
    className: "flex absolute items-center justify-center ".concat((_motif$layouts$find = _utils_type_helper__WEBPACK_IMPORTED_MODULE_5__.motif.layouts.find(function (m) {
      return m.name === state.customize.motifLayout;
    })) === null || _motif$layouts$find === void 0 ? void 0 : _motif$layouts$find.flex),
    style: {
      transform: previewState.position.transform,
      // ! transform: ;
      fontSize: '20px',
      zIndex: 1,
      transformOrigin: 'center',
      top: previewState.position.artTop,
      left: previewState.position.artLeft,
      right: previewState.position.artRight,
      bottom: previewState.position.artBottom
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_common_MotifPreviewCore__WEBPACK_IMPORTED_MODULE_8__.MotifPreviewCore, {
    imageWidth: previewState.charAndMotif.motifShowSize // ! motifShowSize
    ,
    fontSize: function () {
      var font = previewState.charAndMotif.fontSize;
      if (artContainerRef.current) {
        var textSpan = artContainerRef.current.querySelector('span');
        if (textSpan && window.navigator.userAgent.toLowerCase().includes('chrome') && navigator.language && navigator.language === 'ja') {
          if (font < 10 && font !== 0) {
            textSpan.style.transform = "scale(".concat(font / 10, ")");
          } else {
            textSpan.style.transform = "scale(1)";
          }
        }
      }
      return font;
    }() // ! fontsize
    ,

    motifShow: state.customize.motifShow,
    motifPath: state.customize.motifPath,
    characterFont: state.customize.characterFont,
    characterColor: color,
    characterText: state.customize.characterText
  }))));
};

/***/ }),

/***/ "./src/ts/components/product/MotifPreviewWindow.tsx":
/*!**********************************************************!*\
  !*** ./src/ts/components/product/MotifPreviewWindow.tsx ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MotifPreviewWindow": () => (/* binding */ MotifPreviewWindow)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var _utils_type_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/type.helper */ "./src/ts/utils/type.helper.ts");
/* harmony import */ var _hooks_useFontColor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../hooks/useFontColor */ "./src/ts/hooks/useFontColor.tsx");
/* harmony import */ var _common_MotifPreviewCore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../common/MotifPreviewCore */ "./src/ts/components/common/MotifPreviewCore.tsx");






var MotifPreviewWindow = function MotifPreviewWindow(_ref) {
  var _motif$layouts$find;
  var backgroundColor = _ref.backgroundColor,
    width = _ref.width;
  var color = (0,_hooks_useFontColor__WEBPACK_IMPORTED_MODULE_4__.useFontColor)();
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_2__.ProductContext),
    state = _useContext.productState;
  var wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  var commonRatio = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var _document$querySelect;
    var divData = JSON.parse(document.querySelector('#t-product-extra-data') ? (_document$querySelect = document.querySelector('#t-product-extra-data')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.innerHTML : 'null');
    return divData.commonRatio;
  }, []);
  var _useMemo = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
      var _wrapperRef$current, _state$customize$moti;
      var imageWidth = 0;
      var fontSize = 0;
      var lang = state.customize.characterName.includes('字') ? 'EN' : 'JA';
      var baseWidth = (_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.offsetWidth;
      var selectedCharSize = Number(state.customize.characterSize.includes('cm') ? state.customize.characterSize.replace('cm', '') : commonRatio.DefaultFontSize);
      var FONT_RATIO = baseWidth * commonRatio.Lang[lang] * commonRatio.Preview;
      fontSize = FONT_RATIO * selectedCharSize;
      imageWidth = FONT_RATIO * _utils_type_helper__WEBPACK_IMPORTED_MODULE_3__.motifSize[(_state$customize$moti = state.customize.motifSize) !== null && _state$customize$moti !== void 0 ? _state$customize$moti : 'M'].ratio * commonRatio.MotifFont / commonRatio.Lang[lang];
      if (state.preview.isMask) {
        fontSize *= 3;
        imageWidth *= 3;
      }
      return [imageWidth, fontSize];
    }, [commonRatio.Lang, commonRatio.MotifFont, commonRatio.Preview, commonRatio.DefaultFontSize, state.customize.characterName, state.customize.characterSize, state.customize.motifSize, state.preview.isMask]),
    _useMemo2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useMemo, 2),
    imageWidth = _useMemo2[0],
    fontSize = _useMemo2[1];
  var params = {
    imageWidth: imageWidth,
    fontSize: fontSize,
    motifShow: state.customize.motifShow,
    motifPath: state.customize.motifPath,
    characterFont: state.customize.characterFont,
    characterColor: color,
    characterText: state.customize.characterText
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    ref: wrapperRef,
    id: "motif-preview",
    className: "flex items-center justify-center ".concat((_motif$layouts$find = _utils_type_helper__WEBPACK_IMPORTED_MODULE_3__.motif.layouts.find(function (m) {
      return m.name === state.customize.motifLayout;
    })) === null || _motif$layouts$find === void 0 ? void 0 : _motif$layouts$find.flex),
    style: {
      width: width,
      backgroundColor: backgroundColor
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_common_MotifPreviewCore__WEBPACK_IMPORTED_MODULE_5__.MotifPreviewCore, params));
};

/***/ }),

/***/ "./src/ts/components/product/MotifResultContainer.tsx":
/*!************************************************************!*\
  !*** ./src/ts/components/product/MotifResultContainer.tsx ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MotifResultContainer": () => (/* binding */ MotifResultContainer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _MotifCell__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./MotifCell */ "./src/ts/components/product/MotifCell.tsx");
/* harmony import */ var _hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../hooks/useIsMobile */ "./src/ts/hooks/useIsMobile.tsx");
/* harmony import */ var _utils_TEXT__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/TEXT */ "./src/ts/utils/TEXT.ts");




var MotifResultContainer = function MotifResultContainer(_ref) {
  var motifs = _ref.motifs,
    total = _ref.total;
  var isMobile = (0,_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_2__.useIsMobile)();
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "w-full p-6 bg-gray-100 border border-gray-300 top-24"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "grid justify-items-center ".concat(isMobile ? 'grid-cols-3 gap-2' : 'grid-cols-5 gap-3')
  }, total > 0 && motifs.map(function (motif, index) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_MotifCell__WEBPACK_IMPORTED_MODULE_1__.MotifCell, {
      key: "".concat(motif.name, "-").concat(index),
      motif: motif
    });
  })), !total && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, _utils_TEXT__WEBPACK_IMPORTED_MODULE_3__["default"].PRODUCT.MOTIF.NO));
};

/***/ }),

/***/ "./src/ts/components/product/ProductMain.tsx":
/*!***************************************************!*\
  !*** ./src/ts/components/product/ProductMain.tsx ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ProductMain": () => (/* binding */ ProductMain)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../utils/constants */ "./src/ts/utils/constants.ts");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var _TopBreadcrumb__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./TopBreadcrumb */ "./src/ts/components/product/TopBreadcrumb.tsx");
/* harmony import */ var _TopProductInfo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./TopProductInfo */ "./src/ts/components/product/TopProductInfo.tsx");
/* harmony import */ var _hooks_useProductDivData__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../hooks/useProductDivData */ "./src/ts/hooks/useProductDivData.tsx");
/* harmony import */ var _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/type.helper */ "./src/ts/utils/type.helper.ts");
/* harmony import */ var _CustomizeContent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./CustomizeContent */ "./src/ts/components/product/CustomizeContent.tsx");









// const CustomizeContent = lazy(() => import('./CustomizeContent'));

var ProductMain = function ProductMain() {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_2__.ProductContext),
    dispatch = _useContext.productDispatch,
    state = _useContext.productState;
  var _useProductDivData = (0,_hooks_useProductDivData__WEBPACK_IMPORTED_MODULE_5__.useProductDivData)(),
    type = _useProductDivData.type;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    dispatch({
      type: _utils_constants__WEBPACK_IMPORTED_MODULE_1__.ProductPage.EMPTY_ALL_CUSTOMIZE,
      isInit: true
    });
  }, [dispatch]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    window.addEventListener('beforeunload', function () {
      localStorage.setItem(_utils_constants__WEBPACK_IMPORTED_MODULE_1__.TOWEL_LOCAL_STORAGE_PRODUCT_CUSTOMIZE_DATA, JSON.stringify({
        customize: state.customize,
        currentVariant: state.currentVariant
      }));
    });
  }, [state]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    id: "t-product-shopify-info",
    className: "w-11/12 mx-auto font-medium lg:w-5/6 text-towel-product-gray-middle"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TopBreadcrumb__WEBPACK_IMPORTED_MODULE_3__.TopBreadcrumb, null), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TopProductInfo__WEBPACK_IMPORTED_MODULE_4__.TopProductInfo, null), state.preview.customizable && (type || _utils_type_helper__WEBPACK_IMPORTED_MODULE_6__.customizableTypes.includes(state.product.type)) &&
  /*#__PURE__*/
  // <Suspense fallback={null}>
  react__WEBPACK_IMPORTED_MODULE_0__.createElement(_CustomizeContent__WEBPACK_IMPORTED_MODULE_7__["default"], null)
  // </Suspense>
  ));
};

/***/ }),

/***/ "./src/ts/components/product/SectionHeader.tsx":
/*!*****************************************************!*\
  !*** ./src/ts/components/product/SectionHeader.tsx ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SectionHeader": () => (/* binding */ SectionHeader)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");

var SectionHeader = function SectionHeader(_ref) {
  var title = _ref.title,
    children = _ref.children,
    index = _ref.index;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "w-full mt-3 lg:mt-5 __product_info_section_".concat(index)
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("h3", {
    className: "py-2 mb-6 text-base font-medium text-black border-b border-gray-600 lg:mb-10 lg:text-lg"
  }, "[".concat(title, "]")), children));
};

/***/ }),

/***/ "./src/ts/components/product/SlideImg.tsx":
/*!************************************************!*\
  !*** ./src/ts/components/product/SlideImg.tsx ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SlideImg": () => (/* binding */ SlideImg)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");


var SlideImg = function SlideImg(_ref) {
  var src = _ref.src,
    top = _ref.top,
    title = _ref.title;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
    _useState2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useState, 2),
    touching = _useState2[0],
    setTouching = _useState2[1];
  var className = 'object-contain ';
  className += touching ? 'cursor-grabbing ' : 'cursor-grab ';
  className += top ? 't-slider-image-top' : 'px-1 pt-2 t-slider-image-bottom';
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("img", {
    key: src,
    className: className,
    onMouseDown: function onMouseDown() {
      return setTouching(function (touch) {
        return !touch;
      });
    },
    onTouchStart: function onTouchStart() {
      return setTouching(function (touch) {
        return !touch;
      });
    },
    onMouseUp: function onMouseUp() {
      return setTouching(function (touch) {
        return !touch;
      });
    },
    onTouchEnd: function onTouchEnd() {
      return setTouching(function (touch) {
        return !touch;
      });
    },
    height: "".concat(top ? 635 : 208),
    width: "".concat(top ? 962 : 321),
    src: src,
    alt: title
  });
};

/***/ }),

/***/ "./src/ts/components/product/TopBreadcrumb.tsx":
/*!*****************************************************!*\
  !*** ./src/ts/components/product/TopBreadcrumb.tsx ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TopBreadcrumb": () => (/* binding */ TopBreadcrumb)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");


var TopBreadcrumb = function TopBreadcrumb() {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_1__.ProductContext),
    productState = _useContext.productState;
  var vendorName = productState.product.vendor.replace(/ /g, '-');
  if (vendorName.slice(-1) == '-') {
    vendorName = vendorName.slice(0, -1);
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("section", {
    id: "t-product-detail-top __product_breadcrumb"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "/collections/all",
    className: "underline"
  }, "\u30AB\u30C6\u30B4\u30EA"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "px-2"
  }, '>'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "/collections/".concat(vendorName),
    className: "underline"
  }, productState.product.vendor), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "px-2"
  }, '>'), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "/collections/".concat(productState.product.type),
    className: "underline"
  }, productState.product.type));
};

/***/ }),

/***/ "./src/ts/components/product/TopButtonGroups.tsx":
/*!*******************************************************!*\
  !*** ./src/ts/components/product/TopButtonGroups.tsx ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TopButtonGroups": () => (/* binding */ TopButtonGroups)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _common_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../common/Button */ "./src/ts/components/common/Button.tsx");
/* harmony import */ var _hooks_useAddCart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../hooks/useAddCart */ "./src/ts/hooks/useAddCart.tsx");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/constants */ "./src/ts/utils/constants.ts");
/* harmony import */ var _utils_TEXT__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/TEXT */ "./src/ts/utils/TEXT.ts");
/* harmony import */ var _hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../hooks/useIsMobile */ "./src/ts/hooks/useIsMobile.tsx");
/* harmony import */ var _hooks_useProductDivData__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../hooks/useProductDivData */ "./src/ts/hooks/useProductDivData.tsx");
/* harmony import */ var _utils_type_helper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../utils/type.helper */ "./src/ts/utils/type.helper.ts");









window.initalKeyBoard = true;
window.addEventListener('scroll', function () {
  var _document$querySelect;
  var w = window.outerWidth;
  if (w > 1024) {
    return;
  }
  var productTowelCustomization = document.querySelector('#t-product-towel-customization > h1');
  var productCustomPreview = document.querySelector('.__product_customize_preview');
  var target = document.querySelector('[data-wl-custom-motif-preview]');
  var header = document.querySelector('#shopify-section-t-header');
  var input = (_document$querySelect = document.querySelector('#t-product-towel-customization')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.querySelector('input');
  if (input) {
    if (!window.initalKeyBoard) {
      input.blur();
      window.initalKeyBoard = true;
    }
  }
  if (productTowelCustomization && productCustomPreview && target && header) {
    var productTowelCustomizationPosition = productTowelCustomization.getBoundingClientRect();
    var productCustomPreviewPosition = productCustomPreview.getBoundingClientRect();
    if (productTowelCustomizationPosition.top - target.clientHeight - header.clientHeight <= 0) {
      target.classList.remove('invisible');
      target.classList.add('fixed');
    } else {
      target.classList.add('invisible');
      target.classList.remove('fixed');
    }
    if (productCustomPreviewPosition.top - target.getBoundingClientRect().bottom < 0) {
      target.classList.remove('fixed');
    } else {
      target.classList.add('fixed');
    }
  }
});
var TopButtonGroups = function TopButtonGroups(_ref) {
  var _ref$showRight = _ref.showRight,
    showRight = _ref$showRight === void 0 ? true : _ref$showRight;
  var handleSubmit = (0,_hooks_useAddCart__WEBPACK_IMPORTED_MODULE_2__.useAddCart)();
  var isMobile = (0,_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_6__.useIsMobile)();
  var _useProductDivData = (0,_hooks_useProductDivData__WEBPACK_IMPORTED_MODULE_7__.useProductDivData)(),
    type = _useProductDivData.type;
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_3__.ProductContext),
    state = _useContext.productState,
    productDispatch = _useContext.productDispatch;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "".concat(state.preview.customizable && (type || _utils_type_helper__WEBPACK_IMPORTED_MODULE_8__.customizableTypes.includes(state.product.type)) && showRight ? 'grid grid-cols-2 gap-6' : isMobile ? 'mx-auto' : 'w-96 mx-auto', " mt-5")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_common_Button__WEBPACK_IMPORTED_MODULE_1__.Button, {
    submitting: state.submitting,
    onClick: handleSubmit,
    type: "cart",
    content: "".concat(state.currentVariant.available ? _utils_TEXT__WEBPACK_IMPORTED_MODULE_5__["default"].PRODUCT.TOP.ADD_CART : _utils_TEXT__WEBPACK_IMPORTED_MODULE_5__["default"].PRODUCT.TOP.NO_STOCK),
    disabled: !state.currentVariant.available || state.submitting
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "text-xs text-center text-red-600 mt-2"
  }, state.errorMessage)), state.preview.customizable && (type || _utils_type_helper__WEBPACK_IMPORTED_MODULE_8__.customizableTypes.includes(state.product.type)) && showRight && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_common_Button__WEBPACK_IMPORTED_MODULE_1__.Button, {
    onClick: function onClick() {
      productDispatch({
        type: _utils_constants__WEBPACK_IMPORTED_MODULE_4__.ProductPage.TOGGLE_PANEL
      });
      if (state.panelOpen) {
        // close
        localStorage.setItem(_utils_constants__WEBPACK_IMPORTED_MODULE_4__.TOWEL_LOCAL_STORAGE_PANEL_OPEN, 'false');
      } else {
        // open
        localStorage.setItem(_utils_constants__WEBPACK_IMPORTED_MODULE_4__.TOWEL_LOCAL_STORAGE_PANEL_OPEN, 'true');
        setTimeout(function () {
          var header = document.querySelector('#shopify-section-t-header');
          if (!header) {
            return;
          }
          var motifPreviewHeight = state.preview.isPreviewable ? '25vh' : '50vh';
          var w = window.outerWidth;
          var headerHeight = 0 + 'px';
          if (w < 767) {
            headerHeight = header.clientHeight + 'px';
          }
          var panel = document.getElementById('t-product-towel-customization');
          if (panel) {
            panel.style.setProperty('--scrollMargin', "calc(".concat(motifPreviewHeight, " + ").concat(headerHeight, ")"));
            panel.scrollIntoView({
              behavior: 'smooth'
            });
          }
        });
      }
    },
    type: "customize",
    content: state.panelOpen ? _utils_TEXT__WEBPACK_IMPORTED_MODULE_5__["default"].PRODUCT.TOP.NO_CUSTOMIZE : _utils_TEXT__WEBPACK_IMPORTED_MODULE_5__["default"].PRODUCT.TOP.CUSTOMIZE,
    disabled: !state.currentVariant.available || state.submitting
  })));
};

/***/ }),

/***/ "./src/ts/components/product/TopDescription.tsx":
/*!******************************************************!*\
  !*** ./src/ts/components/product/TopDescription.tsx ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TopDescription": () => (/* binding */ TopDescription)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var _utils_TEXT__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/TEXT */ "./src/ts/utils/TEXT.ts");
/* harmony import */ var _HTMLGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./HTMLGenerator */ "./src/ts/components/product/HTMLGenerator.tsx");
/* harmony import */ var _SectionHeader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./SectionHeader */ "./src/ts/components/product/SectionHeader.tsx");





var TopDescription = function TopDescription(_ref) {
  var html = _ref.html;
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_1__.ProductContext),
    productState = _useContext.productState;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    id: "t-product-shopify-description"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_SectionHeader__WEBPACK_IMPORTED_MODULE_4__.SectionHeader, {
    title: _utils_TEXT__WEBPACK_IMPORTED_MODULE_2__["default"].PRODUCT.TOP.PRODUCT_DETAIL,
    index: 3
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_HTMLGenerator__WEBPACK_IMPORTED_MODULE_3__.HTMLGenerator, {
    html: html
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_HTMLGenerator__WEBPACK_IMPORTED_MODULE_3__.HTMLGenerator, {
    html: productState.product.description
  })));
};

/***/ }),

/***/ "./src/ts/components/product/TopHeaderPart.tsx":
/*!*****************************************************!*\
  !*** ./src/ts/components/product/TopHeaderPart.tsx ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TopHeaderPart": () => (/* binding */ TopHeaderPart)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _hooks_useMoney__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../hooks/useMoney */ "./src/ts/hooks/useMoney.tsx");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");



var TopHeaderPart = function TopHeaderPart() {
  var formatter = (0,_hooks_useMoney__WEBPACK_IMPORTED_MODULE_1__.useMoney)();
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_2__.ProductContext),
    state = _useContext.productState;
  var tags = state.product.tags;
  var isSale = false;
  var saleTag = '';
  for (var i = 0; i < tags.length; i++) {
    if (tags[i].indexOf('SALE') != -1 && tags[i].indexOf('%') != -1) {
      isSale = true;
      saleTag = tags[i].replace('SALE', '') + 'OFF';
      break;
    }
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "text-gray-700"
  }, "\u5546\u54C1\u30B3\u30FC\u30C9 ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "ml-5"
  }, state.currentVariant.sku)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "mt-2 text-xl text-black lg:text-2xl"
  }, window.Towel.hasOnlyDefaultVariant ? state.product.title : state.product.title + ' ' + state.currentVariant.title), state.currentVariant.compare_at_price && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "mt-6 text-lg text-right text-black lg:text-xl price-del-line"
  }, formatter(state.currentVariant.compare_at_price)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "mt-1 text-right text-xl sale-price"
  }, isSale && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "font-normal mr-2 px-1 text-white text-base"
  }, saleTag), formatter(state.currentVariant.price))), !state.currentVariant.compare_at_price && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", {
    className: "mt-6 text-lg text-right text-black lg:text-xl"
  }, formatter(state.currentVariant.price)));
};

/***/ }),

/***/ "./src/ts/components/product/TopMain.tsx":
/*!***********************************************!*\
  !*** ./src/ts/components/product/TopMain.tsx ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TopMain": () => (/* binding */ TopMain)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _TopButtonGroups__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./TopButtonGroups */ "./src/ts/components/product/TopButtonGroups.tsx");
/* harmony import */ var _HTMLGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./HTMLGenerator */ "./src/ts/components/product/HTMLGenerator.tsx");
/* harmony import */ var _SectionHeader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./SectionHeader */ "./src/ts/components/product/SectionHeader.tsx");
/* harmony import */ var _TopSelections__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./TopSelections */ "./src/ts/components/product/TopSelections.tsx");
/* harmony import */ var _TopServiceOption__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./TopServiceOption */ "./src/ts/components/product/TopServiceOption.tsx");
/* harmony import */ var _TopHeaderPart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./TopHeaderPart */ "./src/ts/components/product/TopHeaderPart.tsx");
/* harmony import */ var _utils_TEXT__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/TEXT */ "./src/ts/utils/TEXT.ts");








var TopMain = function TopMain(_ref) {
  var html = _ref.html,
    slider = _ref.slider,
    colors = _ref.colors;
  var sections = [_utils_TEXT__WEBPACK_IMPORTED_MODULE_7__["default"].PRODUCT.TOP.OPTION_SERVICE, _utils_TEXT__WEBPACK_IMPORTED_MODULE_7__["default"].PRODUCT.TOP.PRODUCT_INFO, _utils_TEXT__WEBPACK_IMPORTED_MODULE_7__["default"].PRODUCT.TOP.COLOR_QUAN];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    id: "t-product-main-info",
    className: "flex flex-col w-full lg:ml-16 lg:w-1/2 __product_info"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TopHeaderPart__WEBPACK_IMPORTED_MODULE_6__.TopHeaderPart, null), sections.map(function (title, index) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_SectionHeader__WEBPACK_IMPORTED_MODULE_3__.SectionHeader, {
      key: title,
      title: title,
      index: index
    }, function () {
      switch (index) {
        case 0:
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TopServiceOption__WEBPACK_IMPORTED_MODULE_5__.TopServiceOption, null);
        case 1:
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_HTMLGenerator__WEBPACK_IMPORTED_MODULE_2__.HTMLGenerator, {
            html: html
          });
        case 2:
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TopSelections__WEBPACK_IMPORTED_MODULE_4__.TopSelections, {
            slider: slider,
            colors: colors
          });
        default:
          return null;
      }
    }());
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TopButtonGroups__WEBPACK_IMPORTED_MODULE_1__.TopButtonGroups, null)));
};

/***/ }),

/***/ "./src/ts/components/product/TopProductInfo.tsx":
/*!******************************************************!*\
  !*** ./src/ts/components/product/TopProductInfo.tsx ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TopProductInfo": () => (/* binding */ TopProductInfo)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _hooks_useGetProductDOMValue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../hooks/useGetProductDOMValue */ "./src/ts/hooks/useGetProductDOMValue.tsx");
/* harmony import */ var _hooks_useProductSliders__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../hooks/useProductSliders */ "./src/ts/hooks/useProductSliders.tsx");
/* harmony import */ var _TopDescription__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./TopDescription */ "./src/ts/components/product/TopDescription.tsx");
/* harmony import */ var _TopMain__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./TopMain */ "./src/ts/components/product/TopMain.tsx");
/* harmony import */ var _TopSliderImagesWithColors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./TopSliderImagesWithColors */ "./src/ts/components/product/TopSliderImagesWithColors.tsx");






var TopProductInfo = function TopProductInfo() {
  var _useProductSliders = (0,_hooks_useProductSliders__WEBPACK_IMPORTED_MODULE_2__.useProductSliders)(),
    nav1 = _useProductSliders.nav1,
    nav2 = _useProductSliders.nav2,
    slider1 = _useProductSliders.slider1,
    slider = _useProductSliders.slider2;
  var _useGetProductDOMValu = (0,_hooks_useGetProductDOMValue__WEBPACK_IMPORTED_MODULE_1__.useGetProductDOMValue)(),
    html1 = _useGetProductDOMValu.html1,
    html2 = _useGetProductDOMValu.html2,
    colors = _useGetProductDOMValu.colors;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("section", {
    className: "justify-between mx-auto mt-6 text-base lg:text-lg lg:flex"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TopSliderImagesWithColors__WEBPACK_IMPORTED_MODULE_5__.TopSliderImagesWithColors, {
    nav1: nav1,
    nav2: nav2,
    slider1: slider1,
    slider: slider,
    colors: colors
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TopMain__WEBPACK_IMPORTED_MODULE_4__.TopMain, {
    html: html2,
    slider: slider,
    colors: colors
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TopDescription__WEBPACK_IMPORTED_MODULE_3__.TopDescription, {
    html: html1
  }));
};

/***/ }),

/***/ "./src/ts/components/product/TopSelections.tsx":
/*!*****************************************************!*\
  !*** ./src/ts/components/product/TopSelections.tsx ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TopSelections": () => (/* binding */ TopSelections)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _hooks_useSelectVariant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../hooks/useSelectVariant */ "./src/ts/hooks/useSelectVariant.tsx");
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/constants */ "./src/ts/utils/constants.ts");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var _common_QuantitySelection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../common/QuantitySelection */ "./src/ts/components/common/QuantitySelection.tsx");





var TopSelections = function TopSelections(_ref) {
  var slider = _ref.slider,
    colors = _ref.colors;
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_3__.ProductContext),
    state = _useContext.productState,
    dispatch = _useContext.productDispatch;
  var selectVariant = (0,_hooks_useSelectVariant__WEBPACK_IMPORTED_MODULE_1__.useSelectVariant)();
  var changeVariantQuantity = function changeVariantQuantity(value) {
    var isOnChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var quantity = isOnChange ? value - state.currentVariant.quantity : value;
    dispatch({
      type: _utils_constants__WEBPACK_IMPORTED_MODULE_2__.ProductPage.CHANGE_VARIANT,
      variant: {
        quantity: quantity
      }
    });
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "grid grid-cols-5 gap-4 text-base justify-items-start place-items-center"
  }, state.product.variants.length > 1 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", null, "\u30AB\u30E9\u30FC"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("select", {
    name: "option",
    id: "t-color",
    onChange: function onChange(e) {
      var index = e.target.selectedIndex;
      selectVariant(slider.current, index, dispatch, state, colors[index]);
    },
    className: "w-full col-start-2 col-end-5 t-input-box",
    value: state.currentVariant.variantId
  }, state.product.variants.map(function (variant) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("option", {
      key: variant.id,
      value: variant.id
    }, variant.title);
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_common_QuantitySelection__WEBPACK_IMPORTED_MODULE_4__.QuantitySelection, {
    quantity: Math.abs(state.currentVariant.quantity),
    handleChange: changeVariantQuantity
  })));
};

/***/ }),

/***/ "./src/ts/components/product/TopServiceOption.tsx":
/*!********************************************************!*\
  !*** ./src/ts/components/product/TopServiceOption.tsx ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TopServiceOption": () => (/* binding */ TopServiceOption)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var _utils_TEXT__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/TEXT */ "./src/ts/utils/TEXT.ts");
/* harmony import */ var _common_QuestionMark__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../common/QuestionMark */ "./src/ts/components/common/QuestionMark.tsx");
/* harmony import */ var _common_ServiceLabel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../common/ServiceLabel */ "./src/ts/components/common/ServiceLabel.tsx");





var TopServiceOption = function TopServiceOption() {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_1__.ProductContext),
    productState = _useContext.productState;
  var services = [{
    service: _utils_TEXT__WEBPACK_IMPORTED_MODULE_2__["default"].COMMON.EMBRO,
    can: productState.preview.customizable
  }, {
    service: _utils_TEXT__WEBPACK_IMPORTED_MODULE_2__["default"].COMMON.GIFTBOX,
    can: productState.preview.isGiftbox
  }, {
    service: _utils_TEXT__WEBPACK_IMPORTED_MODULE_2__["default"].COMMON.WRAPPING,
    can: productState.preview.isWrapping
  }];
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "grid grid-cols-2 gap-3 lg:grap-4 xl:grid-cols-3 justify-items-start"
  }, services.filter(function (s) {
    return s.can;
  }).map(function (s) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_common_ServiceLabel__WEBPACK_IMPORTED_MODULE_4__.ServiceLabel, {
      key: s.service,
      service: s.service
    });
  }), productState.preview.customizable && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_common_QuestionMark__WEBPACK_IMPORTED_MODULE_3__.QuestionMark, {
    src: "/pages/shishu-guide",
    text: _utils_TEXT__WEBPACK_IMPORTED_MODULE_2__["default"].PRODUCT.TOP.SERVICE_DETAIL
  }));
};

/***/ }),

/***/ "./src/ts/components/product/TopSliderImagesWithColors.tsx":
/*!*****************************************************************!*\
  !*** ./src/ts/components/product/TopSliderImagesWithColors.tsx ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TopSliderImagesWithColors": () => (/* binding */ TopSliderImagesWithColors)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react-slick */ "./node_modules/react-slick/lib/index.js");
/* harmony import */ var _hooks_useSelectVariant__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../hooks/useSelectVariant */ "./src/ts/hooks/useSelectVariant.tsx");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var _SlideImg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./SlideImg */ "./src/ts/components/product/SlideImg.tsx");
/* harmony import */ var _hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../hooks/useIsMobile */ "./src/ts/hooks/useIsMobile.tsx");







var TopSliderImagesWithColors = function TopSliderImagesWithColors(_ref) {
  var nav1 = _ref.nav1,
    nav2 = _ref.nav2,
    slider1 = _ref.slider1,
    slider = _ref.slider,
    colors = _ref.colors;
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_4__.ProductContext),
    state = _useContext.productState,
    dispatch = _useContext.productDispatch;
  var selectVariant = (0,_hooks_useSelectVariant__WEBPACK_IMPORTED_MODULE_3__.useSelectVariant)();
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0),
    _useState2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_useState, 2),
    currentIndex = _useState2[0],
    setCurrentIndex = _useState2[1];
  var isMobile = (0,_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_6__.useIsMobile)();
  var Colors = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      className: "mx-auto"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
      className: "flex flex-wrap justify-center my-3"
    }, colors && colors.length && colors.map(function (color, index) {
      var isSelected = index + 1 === currentIndex ? 'ring-2' : '';
      /** image order adjust */
      // const isSelected = index === currentIndex ? 'ring-2' : ''; no need
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
        key: color + index,
        onClick: function onClick() {
          return selectVariant(slider.current, index, dispatch, state, color);
        },
        style: {
          backgroundColor: color
        },
        className: "t-product-color-circle ".concat(isSelected).trim()
      });
    })));
  }, [currentIndex, selectVariant, slider, dispatch, state, colors]);
  var tags = state.product.tags;
  var isSale = false;
  for (var i = 0; i < tags.length; i++) {
    if (tags[i].indexOf('SALE') != -1) {
      isSale = true;
      break;
    }
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    id: "t-product-images",
    className: "w-full lg:w-1/2 relative"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(react_slick__WEBPACK_IMPORTED_MODULE_2__["default"], {
    arrows: false,
    asNavFor: nav2,
    ref: function ref(sliderRef) {
      return slider1.current = sliderRef;
    },
    beforeChange: function beforeChange(_, nextSlide) {
      return setCurrentIndex(nextSlide);
    }
  }, state.product.images.length && state.product.images.map(function (src) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_SlideImg__WEBPACK_IMPORTED_MODULE_5__.SlideImg, {
      key: src,
      src: src,
      top: true,
      title: state.product.title
    });
  })), state.product.images.length && state.product.images.length > 3 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(react_slick__WEBPACK_IMPORTED_MODULE_2__["default"], {
    asNavFor: nav1,
    arrows: !isMobile,
    ref: function ref(sliderRef) {
      return slider.current = sliderRef;
    },
    slidesToShow: 3,
    beforeChange: function beforeChange(_, nextSlide) {
      return setCurrentIndex(nextSlide);
    },
    swipeToSlide: true,
    focusOnSelect: true
  }, state.product.images.length && state.product.images.map(function (src) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_SlideImg__WEBPACK_IMPORTED_MODULE_5__.SlideImg, {
      key: src,
      src: src,
      top: false,
      title: state.product.title
    });
  })), !window.Towel.hasOnlyDefaultVariant && Colors, isSale && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("div", {
    className: "absolute text-white text-center text-xl sale-tag-batch"
  }, "SALE")));
};

/***/ }),

/***/ "./src/ts/components/product/svgs/BgLoop.tsx":
/*!***************************************************!*\
  !*** ./src/ts/components/product/svgs/BgLoop.tsx ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");

var BgLoop = function BgLoop(_ref) {
  var style = _ref.style,
    backgroundColor = _ref.backgroundColor,
    onLoad = _ref.onLoad;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
    version: "1.1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    onLoad: onLoad,
    x: "0px",
    y: "0px",
    viewBox: "0 0 1364.91 1525.69",
    xmlSpace: "preserve",
    style: style
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    id: "\u30EC\u30A4\u30E4\u30FC_1"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    className: "st0",
    d: "M693.88,225.96c0,0,1.5-33.43,3.63-51.26c2.8-23.41,6.97-38.32,14.74-73.3c7.37-33.23,5.06-54.39,3.79-61.71 c0.04,0.04,0.07,0.05,0.06,0c-0.12-0.6-0.26-1.17-0.39-1.75c-0.16-0.75-0.26-1.13-0.26-1.13l-0.01-0.01 c-2.98-12.2-7.68-18.75-7.68-18.75s-9.18-14.77-25.3-15.32c-16.13,0.56-25.3,15.32-25.3,15.32s-4.7,6.55-7.67,18.75l-0.01,0.01 c0,0-0.11,0.4-0.27,1.17c-0.13,0.56-0.26,1.12-0.38,1.71c-0.01,0.05,0.02,0.04,0.06,0c-1.27,7.31-3.58,28.47,3.79,61.71 c7.77,34.98,12.73,43.99,16.37,70.45c4.21,30.6,2.44,54.11,2.44,54.11s9.88,1.2,9.92,1.05l1.06-7.77 c0.56-26.32,2.26-41.13-10.57-98.71c-2.56-11.49-12.36-38.32-9.61-71.08c2.01-23.88,14.61-29.72,15.48-30.1 c1.92-0.92,3.08-1.1,4.7-1.1c1.61,0,3.31,0.36,4.7,1.1c0.87,0.37,13.47,6.22,15.48,30.1c2.75,32.76-7.59,59.49-9.61,71.08 c-12.17,69.86-8.56,82.84-8.56,104.99L693.88,225.96z"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: "200.57",
    y: "361.34",
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 796.1428 -235.5925)",
    className: "st11loop",
    width: "963.78",
    height: "963.78",
    fill: backgroundColor
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
    x: "214.74",
    y: "375.52",
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 796.1428 -235.5925)",
    className: "st12loop",
    width: "935.43",
    height: "935.43",
    fill: backgroundColor
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    id: "\u30EC\u30A4\u30E4\u30FC_2",
    className: "st13"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("polygon", {
    id: "SVGID_1_",
    points: "-1726.46,-989.45 -779.98,-984.55 -628.99,-644.13 -738.03,-61.14 -999.47,205.89  -1826.42,-639.23 \t\t\t"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: 'visible'
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    className: "st15"
  }))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BgLoop);

/***/ }),

/***/ "./src/ts/components/product/svgs/Index.tsx":
/*!**************************************************!*\
  !*** ./src/ts/components/product/svgs/Index.tsx ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BgLoop": () => (/* reexport safe */ _BgLoop__WEBPACK_IMPORTED_MODULE_0__["default"])
/* harmony export */ });
/* harmony import */ var _BgLoop__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BgLoop */ "./src/ts/components/product/svgs/BgLoop.tsx");


/***/ }),

/***/ "./src/ts/product.tsx":
/*!****************************!*\
  !*** ./src/ts/product.tsx ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react-dom */ "./node_modules/react-dom/index.js");
/* harmony import */ var _widgets_TowelProduct__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./widgets/TowelProduct */ "./src/ts/widgets/TowelProduct.tsx");
/* harmony import */ var smoothscroll_polyfill__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! smoothscroll-polyfill */ "./node_modules/smoothscroll-polyfill/dist/smoothscroll.js");
/* harmony import */ var smoothscroll_polyfill__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(smoothscroll_polyfill__WEBPACK_IMPORTED_MODULE_3__);




if (document.getElementById('t-ts-product-detail')) {
  smoothscroll_polyfill__WEBPACK_IMPORTED_MODULE_3___default().polyfill();
  var product = document.getElementById('t-ts-product-detail');
  react_dom__WEBPACK_IMPORTED_MODULE_1__.render( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_widgets_TowelProduct__WEBPACK_IMPORTED_MODULE_2__.TowelProduct, null), product);
}

/***/ }),

/***/ "./src/ts/widgets/TowelProduct.tsx":
/*!*****************************************!*\
  !*** ./src/ts/widgets/TowelProduct.tsx ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TowelProduct": () => (/* binding */ TowelProduct)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react-query */ "./node_modules/react-query/es/index.js");
/* harmony import */ var _components_product_ProductMain__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../components/product/ProductMain */ "./src/ts/components/product/ProductMain.tsx");
/* harmony import */ var _utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/contexts/ProductContext */ "./src/ts/utils/contexts/ProductContext.tsx");
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../utils/helpers */ "./src/ts/utils/helpers.ts");





var queryClient = new react_query__WEBPACK_IMPORTED_MODULE_1__.QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});
var TowelProduct = function TowelProduct() {
  (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_4__.hideLoader)();
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react_query__WEBPACK_IMPORTED_MODULE_1__.QueryClientProvider, {
    client: queryClient
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_utils_contexts_ProductContext__WEBPACK_IMPORTED_MODULE_3__.ProductProvider, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_components_product_ProductMain__WEBPACK_IMPORTED_MODULE_2__.ProductMain, null)));
};

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"product": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunksrc"] = self["webpackChunksrc"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["product-lib","react","vendor","custom"], () => (__webpack_require__("./src/ts/product.tsx")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;